import { Component, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CQMSConfigurationService } from 'src/app/Services/CQMSConfiguration/cqmsconfiguration.service';
import { ToastrService } from 'ngx-toastr';
import { measureQualifyName } from 'src/app/models/measureQualifyName';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { ICqmsVisitNoteDetails } from 'src/app/models/ICqmsVisitNoteDetails';
import { CQMSVisitNoteFlag } from 'src/app/models/CQMSVisitNoteFlag';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { VisitNoteHeaderComponent } from 'src/app/PatientChart/visit-note-header/visit-note-header.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { I } from '@angular/cdk/keycodes';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
// import { EventEmitter } from 'protractor';

@Component({
  selector: 'app-cqms',
  templateUrl: './cqms.component.html',
  styleUrls: ['./cqms.component.css'],
  providers: [NgxSpinnerService]
})
export class CqmsComponent implements OnInit, OnChanges {
  bmiScreenTooltip: string = '';
  visitNoteCQMSForm: FormGroup;
  isCQMSDBButtonShow: boolean = false;
  public chkcancel: boolean = false;
  @Input() isupdate = '';
  @Output() cqmstactiveTab2 = new EventEmitter()
  public measurequalifyNameList: measureQualifyName[] = [];
  advanceCareList: measureQualifyName[] = [];
  osteoporosisList: measureQualifyName[] = [];
  pneumococcalList: measureQualifyName[] = [];
  preventAndScreenList: measureQualifyName[] = [];
  closingRefList: measureQualifyName[] = [];
  opioidTherapy: measureQualifyName[] = [];
  documentationSignList: measureQualifyName[] = [];
  evaluationOrInterviewList: measureQualifyName[] = [];
  bmiScreeningList: measureQualifyName[] = [];
  documentationCurentMedList: measureQualifyName[] = [];
  highRiskMedList: measureQualifyName[] = [];
  highRiskMedC2List: measureQualifyName[] = [];
  TabacooC1List: measureQualifyName[] = [];
  TabacooC2List: measureQualifyName[] = [];
  TabacooC3List: measureQualifyName[] = [];
  AlcoholUseC1List: measureQualifyName[] = [];
  AlcoholUseC2List: measureQualifyName[] = [];
  AlcoholUseC3List: measureQualifyName[] = [];
  DepressionList: measureQualifyName[] = [];
  public result: any;
  public cqmsMainObject: ICqmsVisitNoteDetails[] = [];
  cqmsVisitNoteObjAdvanceCare: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteObjOsteoporosis: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteObjPneumococcal: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteRiskC2: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteBMI: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteObjDocCurMed: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  //cqmsVisitNoteObj6: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  //cqmsVisitNoteObj7: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  //cqmsVisitNoteObj8: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteObjHighRiskMed1: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteObjCLR: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteObjTobacco1: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteObjTobacco2: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteObjTobacco3: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteObjAlcohol1: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteObjAlcohol2: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteObjAlcohol3: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  cqmsVisitNoteObjDepression: ICqmsVisitNoteDetails = new ICqmsVisitNoteDetails();
  newencId: string;
  isnewencounter: boolean = false;
  encounterId: string;
  cqmsVisitNoteList: ICqmsVisitNoteDetails[];

  advanceCareOptions: Observable<measureQualifyName[]>;
  //  pneumococcalOptions: Observable<measureQualifyName[]>;
  preventAndScreenOptions: Observable<measureQualifyName[]>;
  bmiScreenOptions: Observable<measureQualifyName[]>;
  // docCurrentScreenOptions: Observable<measureQualifyName[]>;
  opioidTherapyScreenOptions: Observable<measureQualifyName[]>;
  documentationSignScreenOptions: Observable<measureQualifyName[]>;
  evaluationInterviewScreenOptions: Observable<measureQualifyName[]>;
  // closeRefScreenOptions: Observable<measureQualifyName[]>;
  highRiskMedOptions: Observable<measureQualifyName[]>;
  highRiskCriteriaTwoOptions: Observable<measureQualifyName[]>;


  cqmsnotes: string;
  public advanceCareId: string;
  public osteoporosisId: string = '';
  public pneumococcalId: string;
  public preventId: string;
  public bmiId: string;
  public docCurrentMedId: string;
  public opioidTherapyId: string;
  public documentationSignId: string;
  public evaluationId: string;
  public bmiMeasureId: number;
  public highRiskMedId: string;
  public closeRefId: string;
  public IsChenageBMIMeasureId: boolean = false;
  public highRiskMedC2Id: string;
  public Tobacco1Id: string;


  flagsList: CQMSVisitNoteFlag[] = [];

  encBmiVal: string;
  encBMIDate: Date;

  isbmiShow: boolean = true;
  isBMICrossOrRight: boolean = false;

  isTabaccoShow1: boolean = true;
  isTabaccco1CrossOrRight: boolean = false;
  TabaccoC1Desc: string;
  TabaccoC1Date: Date;

  isTabaccoShow2: boolean = true;
  isTabaccco2CrossOrRight: boolean = false;
  TabaccoC2Desc: string;
  TabaccoC2Date: Date;


  isTabaccoShow3: boolean = true;
  isTabaccco3CrossOrRight: boolean = false;
  TabaccoC3Desc: string;
  TabaccoC3Date: Date;

  isAlcoholUseShow1: boolean = true;
  isAlcoholUseC1CrossOrRight: boolean = false;
  AlcoholUseC1Desc!: string;
  AlcoholUseC1Date: Date | null = null;
  isAlcoholC2Disabled: boolean = false;
  isAlcoholC3Disabled: boolean = false;

  isAlcoholUseShow2: boolean = true;
  isAlcoholUseC2CrossOrRight: boolean = false;
  AlcoholUseC2Desc!: string;
  AlcoholUseC2Date: Date | null = null;

  isAlcoholUseShow3: boolean = true;
  isAlcoholUseC3CrossOrRight: boolean = false;
  AlcoholUseC3Desc!: string;
  AlcoholUseC3Date: Date | null = null;

  encQualifyDesc: string;
  encPreviousDate: Date;

  advanceDesc: string;
  encAdvanceCareDate: Date;
  isAdvanceShow: boolean = true;
  isAdvanceCrossOrRight: boolean = false;

  OsteoporosisDesc: string = '';
  encOsteoporosisDate: Date | null = null;
  isOsteoporosisShow: boolean = true;
  isOsteoporosisCrossOrRight: boolean = false;

  DepressionDesc: string = '';
  encDepressionDate: Date | null = null;
  isDepressionShow: boolean = true;
  isDepressionCrossOrRight: boolean = false;

  pneumococcalDesc: string;
  encPnemococcalDate: Date;
  isPnemocoShow: boolean = true;
  isPnemocoCrossOrRight: boolean = false;

  opioidTherapyDesc: string;
  opioidTherapyDate: Date;
  isOpioidTherapyShow: boolean = true;
  isOpioidCrossOrRight: boolean = false;

  documentSignedDesc: string;
  documentSignedDate: Date;
  isDocSignShow: boolean = true;
  isDocSignCrossOrRight: boolean = false;

  evaluationInterviewDesc: string;
  evaluationInterviewDate: Date;
  isEvaluationShow: boolean = true;
  isEvaluationCrossOrRight: boolean = false;

  docCurrentMedDesc: string;
  docCurrentMedDate: Date;
  isDocCurrentMedShow: boolean = false;
  isCurrentMedCrossOrRight: boolean = false;

  highRiskMedDesc: string;
  highRiskMedDate: Date;
  isHighRiskMedShow: boolean = false;
  isHighRiskMedCrossOrRight: boolean = false;

  C2highRiskMedDesc: string;
  C2highRiskMedDate: Date;
  isC2HighRiskMedCrossOrRight: Boolean = false;
  isC2HighRiskMedShow: boolean = false;

  CloseRefDate: Date;
  CloseRefDesc: string;
  isCloseRefShow: boolean = false;
  isCloseRefCrossOrRight: Boolean = false;

  ischeckdisable: boolean = false;

  bmiNewScreenList: measureQualifyName[] = [];
  bmi: number = 0;
  isadvanceValueChange: boolean = false;
  isOsteoporosisValueChange: boolean = false;
  isPneumococcalChange: boolean = false;
  isbmiChange: boolean = false;
  isOpioidChange: boolean = false;
  isEvaluationChange: boolean = false;
  isDocSignChange: boolean = false;
  isDocCurrentMedChange: boolean = false;
  isHighRiskChange: boolean = false;
  isHighRiskC2Change: boolean = false;
  isCloseRefChange: boolean = false;
  isTobacco1Change: boolean = false;
  WidgetDetails: any[];
  @Output() cqmsCancel = new EventEmitter();
  dropwidth: number;
  constructor(private formBuilder: FormBuilder
    , private cqmsConfigurationService: CQMSConfigurationService
    , public datepipe: DatePipe
    , private toastr: ToastrService
    , private router: Router
    , private spinner: NgxSpinnerService
    , private schedulerservice: SchedularServiceService
    //, private visitheader: VisitNoteHeaderComponent
  ) {
    this.getSystem();

    this.WidgetDetails = [
      {
        WidgetFor: "BMI",
        HeaderText: "Preventive Care and Screening: Body Mass Index (BMI) Screening and Follow-Up Plan",
        WidgetData: ["BMI point1", " BMI point2", "BMI point3",]
      },
      {
        WidgetFor: "TC1",
        HeaderText: "Tobacco Use: Screening and Cessation Intervention :Criteria -1 ",
        WidgetData: ["DCM point1", " DCM point2", "DCM point3",]
      },
      {
        WidgetFor: "TC2",
        HeaderText: "Tobacco Use: Screening and Cessation Intervention :Criteria -2 ",
        WidgetData: ["DCM point1", " DCM point2", "DCM point3",]
      }
      , {
        WidgetFor: "TC3",
        HeaderText: "Tobacco Use: Screening and Cessation Intervention :Criteria -3 ",
        WidgetData: ["DCM point1", " DCM point2", "DCM point3",]
      }
      , {
        WidgetFor: "TC4",
        HeaderText: "Documentation of Current Medications in the Medical Record ",
        WidgetData: ["DCM point1", " DCM point2", "DCM point3",]
      }
      , {
        WidgetFor: "TC5",
        HeaderText: "Closing the Referral Loop ",
        WidgetData: ["DCM point1", " DCM point2", "DCM point3",]
      }
      , {
        WidgetFor: "TC6",
        HeaderText: "Pneumococcal Vaccination Status for Older Adults ",
        WidgetData: ["DCM point1", " DCM point2", "DCM point3",]
      }
      , {
        WidgetFor: "TC7",
        HeaderText: "Use of High-Risk Medications in the Elderly (Criteria One) ",
        WidgetData: ["DCM point1", " DCM point2", "DCM point3",]
      }
      , {
        WidgetFor: "TC8",
        HeaderText: "Use of High-Risk Medications in the Elderly (Criteria Two) ",
        WidgetData: ["DCM point1", " DCM point2", "DCM point3",]
      }, {
        WidgetFor: "TC9",
        HeaderText: "Use of High-Risk Medications in the Elderly (Criteria One) ",
        WidgetData: ["DCM point1", " DCM point2", "DCM point3",]
      }
      , {
        WidgetFor: "TC10",
        HeaderText: "Use of High-Risk Medications in the Elderly (Criteria Two) ",
        WidgetData: ["DCM point1", " DCM point2", "DCM point3",]
      }
      , {
        WidgetFor: "TC11",
        HeaderText: "Documentation of Signed Opioid Treatment Agreement ",
        WidgetData: ["DCM point1", " DCM point2", "DCM point3",]
      }, {
        WidgetFor: "TC12",
        HeaderText: " Evaluation or Interview for Risk of Opioid Misuse",
        WidgetData: ["DCM point1", " DCM point2", "DCM point3",]
      }
      , {
        WidgetFor: "AU1",
        HeaderText: "Screening of Unhealthy Alcohol Use (Criteria 1)",
        WidgetData: ["AU point1", " AU point2", "AU point3",]
      }
      , {
        WidgetFor: "AU2",
        HeaderText: "Screening of Unhealthy Alcohol Use (Criteria 2)",
        WidgetData: ["AU point1", " AU point2", "AU point3",]
      }
      , {
        WidgetFor: "AU3",
        HeaderText: "Screening of Unhealthy Alcohol Use (Criteria 3)",
        WidgetData: ["AU point1", " AU point2", "AU point3",]
      }

    ];

    //this.get1VisitNoteFlags();
  }

  ngOnInit() {
    this.dropwidth = $('#docCurrentMedScreenDrop').width();
    this.visitNoteCQMSForm = this.formBuilder.group({
      advanceCarePlan: [''],
      osteoporosisScreen: [''],
      pneumococcal: [''],
      preventiveCareScreen: [''],
      bmiScreen: [''],
      docCurrentMedScreen: [''],
      opioidTherapyScreen: [''],
      documentationSignedScreen: [''],
      evaluationInterviewScreen: [''],
      cqmsDescription: [''],
      closeRefScreen: [''],
      highRiskMedScreen: [""],
      highRiskCriteriaTwo: [""],
      TabacooCriteria1Screen: [""],
      TabacooCriteria2Screen: [""],
      TabacooCriteria3Screen: [""],

      TabacooCriteria1ScreenNotes: [""],
      TabacooCriteria2ScreenNotes: [""],
      TabacooCriteria3ScreenNotes: [""],
      docCurrentMedScreenNotes: [""],
      closeRefScreenNotes: [""],
      pneumococcalNotes: [""],
      highRiskMedScreenNotes: [""],
      highRiskMedScreenC2Notes: [""],
      bmiScreenNotes: [""],
      AlcoholUseCriteria1Screen: [""],
      AlcoholUseCriteria1ScreenNotes: [""],
      AlcoholUseCriteria2Screen: [""],
      AlcoholUseCriteria2ScreenNotes: [""],
      AlcoholUseCriteria3Screen: [""],
      AlcoholUseCriteria3ScreenNotes: [""],
      depressionScreen: [""],
      depressionScreenNotes: [""],
    });
    //this.getVisitNoteInfo();
    // this.getVisitNoteFlags();
    Header: " Header Heading"
    Dispalydata: ""
    this.getvistcptcode();


  }

  getwidgetData(query: string) {
    return this.WidgetDetails.filter(item => item.WidgetFor == query)
  }

  getSystem() {
    if (sessionStorage.getItem("encounterid") != null || sessionStorage.getItem("encounterid") != undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
    if (sessionStorage.getItem("isCQMSVisitNote") != null || sessionStorage.getItem("isCQMSVisitNote") != undefined) {
      this.isCQMSDBButtonShow = true;
    }
  }

  visitcptcode: string = "";
  getvistcptcode() {

    this.schedulerservice.getVisitDetails(CommonComponents.encounterId).subscribe((data) => {
      if (data) {
        this.visitcptcode = data.visitCPTCode;
      }
    })

  }

  ngOnChanges(changes: SimpleChanges): void {
    //this.getSystem();
    this.spinner.show()
    if (this.visitNoteCQMSForm && this.visitNoteCQMSForm.controls.docCurrentMedScreen)
      this.visitNoteCQMSForm.controls.docCurrentMedScreen.enable();
    if (this.visitNoteCQMSForm && this.visitNoteCQMSForm.controls.closeRefScreen)
      this.visitNoteCQMSForm.controls.closeRefScreen.enable()
    if (this.isupdate != '')
      setTimeout(() => {
        this.getVisitNoteFlags();
        // this.spinner.hide();
      }, 2000);


  }


  async MeasureNameDropDownsBinding(isnewenc: boolean, encId: string) {
    await this.cqmsConfigurationService.GetAllMeasureQualifyNames().subscribe((data: measureQualifyName[]) => {
      // alert('fired');
      this.measurequalifyNameList = data;
      this.documentationCurentMedList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Documentation of Current Medications in the Medical Record');
      this.closingRefList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Closing the Referral Loop');
      this.pneumococcalList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Pneumococcal Vaccination Status for Older Adults');
      this.bmiNewScreenList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Preventive Care and Screening: Body Mass Index (BMI) Screening and Follow-Up Plan');
      this.highRiskMedList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Use of High-Risk Medications in the Elderly (Criteria One)');
      this.TabacooC1List = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Preventive Care and Screening: Tobacco Use: Screening and Cessation Intervention (CRITERIA 1)');
      this.TabacooC2List = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Preventive Care and Screening: Tobacco Use: Screening and Cessation Intervention (CRITERIA 2)');
      this.TabacooC3List = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Preventive Care and Screening: Tobacco Use: Screening and Cessation Intervention (CRITERIA 3)');
      this.AlcoholUseC1List = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Screening of Unhealthy Alcohol Use (Criteria 1)');
      this.AlcoholUseC2List = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Screening of Unhealthy Alcohol Use (Criteria 2)');
      this.AlcoholUseC3List = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Screening of Unhealthy Alcohol Use (Criteria 3)');
      this.advanceCareList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Advance Care Plan');
      this.osteoporosisList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Screening for Osteoporosis');
      this.DepressionList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Preventive Care and Screening: Screening for Depression and Follow-Up Plan');
      // Re-apply the auto-selected Depression code now that its <option> list actually exists — the
      // dropdown's options load asynchronously here, after getVisitNoteFlags() already tried to patch
      // the control, so the earlier patch can land before there is anything for it to match against.
      if (this.flagsList && this.flagsList[0] && this.flagsList[0].Depression && this.flagsList[0].DepressionDesc) {
        this.visitNoteCQMSForm.patchValue({
          depressionScreen: this.flagsList[0].DepressionDesc.split(':')[0]
        });
      }


      //this.advanceCareList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureID == 40);
      // this.pneumococcalList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.cqmsMeasureId == 2);
      this.preventAndScreenList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.cqmsMeasureId == 3);
      //this.closingRefList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.cqmsMeasureId == 34);
      this.opioidTherapy = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.cqmsMeasureId == 7);
      this.documentationSignList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.cqmsMeasureId == 8);
      this.evaluationOrInterviewList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.cqmsMeasureId == 9);
      //this.bmiNewScreenList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.cqmsMeasureId == 13);

      //this.documentationCurentMedList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureID == 4);

      // this.highRiskMedList = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.cqmsMeasureId == 10);
      //this.highRiskMedC2List = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.cqmsMeasureId == 40);
      this.highRiskMedC2List = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.MasterMeasureName == 'Use of High-Risk Medications in the Elderly (Criteria Two)');

      //this.lsttest = this.measurequalifyNameList.filter((attr: measureQualifyName) => attr.cqmsMeasureId == 9);
      //this.bmiScreeningList = Object.assign([], this.bmiNewScreenList);
      if (isnewenc === true) {
        this.saveVisitNoteInfo(encId);
      } else {
        //for updating visit details
       // this.saveVisitNoteInfo(encId);
        this.getVisitNoteInfo();

        this.advanceCarefilter();
        // this.pneumococcalfilter();
        //  this.documentCurrentMedfilter();

        // this.opioidTherapyfilter();
        // this.documentationSignedfilter();
        // this.evaluationInterviewfilter();

        // this.closeRefScreenfilter();
        //this.highRiskMedfilter();

        this.highRiskMedCriteriaTwofilter();
        //this.bmiScreeningfilter();
        this.bindNewBMIScreen();
      }
      this.spinner.hide();
    },
      (err: any) => {
        console.log(err)
        this.spinner.hide();
      })
  }


  createObjects() {
    // #region curmed
    this.cqmsVisitNoteObjDocCurMed.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjDocCurMed.encounterId = this.newencId //CommonComponents.encounterId;
    this.cqmsVisitNoteObjDocCurMed.isActive = true;
    this.cqmsVisitNoteObjDocCurMed.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.cqmsVisitNoteObjDocCurMed.measureId = this.documentationCurentMedList.length > 0 ? this.documentationCurentMedList[0].cqmsMeasureId : 0;
   if(!this.isDocCurrentMedShow)
    {
      this.cqmsVisitNoteObjDocCurMed.measureId = 0;
    }
    this.cqmsVisitNoteObjDocCurMed.qualifyingDescription = "";
    this.cqmsVisitNoteObjDocCurMed.qualifyingCode = 0;
    // if (this.isDocCurrentMedChange) {
    let id = this.visitNoteCQMSForm.value.docCurrentMedScreen.toString();
    this.cqmsVisitNoteObjDocCurMed.qualifyingCode = Number(id);
    let res = this.documentationCurentMedList.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjDocCurMed.qualifyingCode);
    this.cqmsVisitNoteObjDocCurMed.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';
    // }
    this.cqmsVisitNoteObjDocCurMed.Notes = this.visitNoteCQMSForm.value.docCurrentMedScreenNotes.toString();
    //end region
    //closing referal loop
    this.cqmsVisitNoteObjCLR.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjCLR.encounterId = this.newencId //CommonComponents.encounterId;
    this.cqmsVisitNoteObjCLR.isActive = true;
    this.cqmsVisitNoteObjCLR.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.cqmsVisitNoteObjCLR.measureId = this.closingRefList.length > 0 ? this.closingRefList[0].cqmsMeasureId : 0;
    this.cqmsVisitNoteObjCLR.qualifyingDescription = "";
    this.cqmsVisitNoteObjCLR.qualifyingCode = 0;
    this.cqmsVisitNoteObjCLR.Notes = ""
    // if (this.isCloseRefChange) {
    if (this.visitNoteCQMSForm.value.closeRefScreen) {
      id = this.visitNoteCQMSForm.value.closeRefScreen.toString();
      this.cqmsVisitNoteObjCLR.qualifyingCode = Number(id);
      res = this.closingRefList.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjCLR.qualifyingCode);
      this.cqmsVisitNoteObjCLR.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';
      // this.visitNoteCQMSForm.value.closeRefScreen;
      //}

      this.cqmsVisitNoteObjCLR.Notes = this.visitNoteCQMSForm.value.closeRefScreenNotes.toString();
    }
    if(!this.isCloseRefShow){
      this.cqmsVisitNoteObjCLR.measureId =0;
    }

    this.cqmsVisitNoteObjAdvanceCare.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjAdvanceCare.encounterId = this.newencId //CommonComponents.encounterId;
    this.cqmsVisitNoteObjAdvanceCare.isActive = true;
    this.cqmsVisitNoteObjAdvanceCare.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.cqmsVisitNoteObjAdvanceCare.measureId = this.advanceCareList.length > 0 ? this.advanceCareList[0].cqmsMeasureId : 0;

    this.cqmsVisitNoteObjOsteoporosis.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjOsteoporosis.encounterId = this.newencId;
    this.cqmsVisitNoteObjOsteoporosis.isActive = true;
    this.cqmsVisitNoteObjOsteoporosis.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.cqmsVisitNoteObjOsteoporosis.measureId = this.osteoporosisList.length > 0 ? this.osteoporosisList[0].cqmsMeasureId : 0;
    if (!this.isOsteoporosisShow) {
      this.cqmsVisitNoteObjOsteoporosis.measureId = 0;
    }
    if (this.visitNoteCQMSForm.getRawValue().osteoporosisScreen) {
      let osteoId = this.visitNoteCQMSForm.getRawValue().osteoporosisScreen.toString();
      this.cqmsVisitNoteObjOsteoporosis.qualifyingCode = Number(osteoId);
      let osteoRes = this.osteoporosisList.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjOsteoporosis.qualifyingCode);
      this.cqmsVisitNoteObjOsteoporosis.qualifyingDescription = osteoRes.length > 0 ? osteoRes[0].qualifyMeasureName : '';
    }

    this.cqmsVisitNoteObjDepression.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjDepression.encounterId = this.newencId;
    this.cqmsVisitNoteObjDepression.isActive = true;
    this.cqmsVisitNoteObjDepression.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.cqmsVisitNoteObjDepression.measureId = this.DepressionList.length > 0 ? this.DepressionList[0].cqmsMeasureId : 0;
    if (!this.isDepressionShow) {
      this.cqmsVisitNoteObjDepression.measureId = 0;
    }
    this.cqmsVisitNoteObjDepression.qualifyingDescription = this.cqmsVisitNoteObjDepression.qualifyingDescription || "";
    this.cqmsVisitNoteObjDepression.Notes = this.visitNoteCQMSForm.getRawValue().depressionScreenNotes ? this.visitNoteCQMSForm.getRawValue().depressionScreenNotes.toString() : "";
    if (this.visitNoteCQMSForm.getRawValue().depressionScreen) {
      let depressionId = this.visitNoteCQMSForm.getRawValue().depressionScreen.toString();
      this.cqmsVisitNoteObjDepression.qualifyingCode = Number(depressionId);
      let depressionRes = this.DepressionList.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjDepression.qualifyingCode);
      this.cqmsVisitNoteObjDepression.qualifyingDescription = depressionRes.length > 0 ? depressionRes[0].qualifyMeasureName : '';
      this.cqmsVisitNoteObjDepression.isPerfomanceMed = depressionRes.length > 0 ? depressionRes[0].isPerformance : false;
    } else {
      this.cqmsVisitNoteObjDepression.qualifyingCode = 0;
    }
    // if (this.isadvanceValueChange) {
    //   this.cqmsVisitNoteObjAdvanceCare.qualifyingDescription = this.visitNoteCQMSForm.value.advanceCarePlan;
    // }
    if(this.visitNoteCQMSForm.getRawValue().advanceCarePlan){
    let id = this.visitNoteCQMSForm.getRawValue().advanceCarePlan.toString();
    this.cqmsVisitNoteObjAdvanceCare.qualifyingCode = Number(id);
    let res = this.advanceCareList.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjAdvanceCare.qualifyingCode);
    this.cqmsVisitNoteObjAdvanceCare.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';
    } 

    this.cqmsVisitNoteObjPneumococcal.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjPneumococcal.encounterId = this.newencId //CommonComponents.encounterId;
    this.cqmsVisitNoteObjPneumococcal.isActive = true;
    this.cqmsVisitNoteObjPneumococcal.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.cqmsVisitNoteObjPneumococcal.measureId = this.pneumococcalList.length > 0 ? this.pneumococcalList[0].cqmsMeasureId : 0;
    //if (this.isPneumococcalChange) {
    // this.cqmsVisitNoteObjPneumococcal.qualifyingDescription = this.visitNoteCQMSForm.value.pneumococcal;
    //}
    //  this.cqmsVisitNoteObjPneumococcal.Notes = this.visitNoteCQMSForm.value.pneumococcalNotes.toString();

    this.cqmsVisitNoteObjPneumococcal.qualifyingDescription = "";
    this.cqmsVisitNoteObjPneumococcal.qualifyingCode = 0;
    this.cqmsVisitNoteObjPneumococcal.Notes = ""
    // if (this.isCloseRefChange) {
    if (this.visitNoteCQMSForm.value.pneumococcal) {
     
      id = this.visitNoteCQMSForm.value.pneumococcal.toString();
      this.cqmsVisitNoteObjPneumococcal.qualifyingCode = Number(id);
      res = this.pneumococcalList.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjPneumococcal.qualifyingCode);
      this.cqmsVisitNoteObjPneumococcal.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';
      // this.visitNoteCQMSForm.value.closeRefScreen;
      //}

      this.cqmsVisitNoteObjPneumococcal.Notes = this.visitNoteCQMSForm.value.pneumococcalNotes.toString();
    }
    if(!this.isPnemocoShow){
      this.cqmsVisitNoteObjPneumococcal.measureId = 0;
    }

    this.cqmsVisitNoteObjHighRiskMed1.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjHighRiskMed1.encounterId = this.newencId //CommonComponents.encounterId;
    this.cqmsVisitNoteObjHighRiskMed1.isActive = true;
    this.cqmsVisitNoteObjHighRiskMed1.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.cqmsVisitNoteObjHighRiskMed1.measureId = this.highRiskMedList.length > 0 ? this.highRiskMedList[0].cqmsMeasureId : 0;
    // if (this.isHighRiskChange) {
    //   this.cqmsVisitNoteObjHighRiskMed1.qualifyingDescription = this.visitNoteCQMSForm.value.highRiskMedScreen;
    // }
    //this.cqmsVisitNoteObjHighRiskMed1.Notes = this.visitNoteCQMSForm.value.highRiskMedScreenNotes.toString();
    //....

    this.cqmsVisitNoteObjHighRiskMed1.qualifyingDescription = "";
    this.cqmsVisitNoteObjHighRiskMed1.qualifyingCode = 0;
    this.cqmsVisitNoteObjHighRiskMed1.Notes = ""
    if (this.visitNoteCQMSForm.value.highRiskMedScreen) {
      id = this.visitNoteCQMSForm.value.highRiskMedScreen.toString();
      this.cqmsVisitNoteObjHighRiskMed1.qualifyingCode = Number(id);
      res = this.highRiskMedList.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjHighRiskMed1.qualifyingCode);
      this.cqmsVisitNoteObjHighRiskMed1.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';


      this.cqmsVisitNoteObjHighRiskMed1.Notes = this.visitNoteCQMSForm.value.highRiskMedScreenNotes.toString();
    }
    if(!this.isHighRiskMedShow){
      this.cqmsVisitNoteObjHighRiskMed1.measureId = 0;
    }



    this.cqmsVisitNoteRiskC2.patId = CommonComponents.patientId;
    this.cqmsVisitNoteRiskC2.encounterId = this.newencId //CommonComponents.encounterId;
    this.cqmsVisitNoteRiskC2.isActive = true;
    this.cqmsVisitNoteRiskC2.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.cqmsVisitNoteRiskC2.measureId = this.highRiskMedC2List.length > 0 ? this.highRiskMedC2List[0].cqmsMeasureId : 0;
    // if (this.isHighRiskC2Change) {
    // this.cqmsVisitNoteRiskC2.qualifyingDescription = this.visitNoteCQMSForm.value.highRiskCriteriaTwo;
    //  }
    // this.cqmsVisitNoteRiskC2.Notes = this.visitNoteCQMSForm.value.highRiskCriteriaTwoNotes;



    this.cqmsVisitNoteRiskC2.qualifyingDescription = "";
    this.cqmsVisitNoteRiskC2.qualifyingCode = 0;
    this.cqmsVisitNoteRiskC2.Notes = ""
    if (this.visitNoteCQMSForm.value.highRiskCriteriaTwo) {
      id = this.visitNoteCQMSForm.value.highRiskCriteriaTwo.toString();
      this.cqmsVisitNoteRiskC2.qualifyingCode = Number(id);
      res = this.highRiskMedC2List.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteRiskC2.qualifyingCode);
      this.cqmsVisitNoteRiskC2.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';


      this.cqmsVisitNoteRiskC2.Notes = this.visitNoteCQMSForm.value.highRiskMedScreenC2Notes.toString();
    }
    if(!this.isC2HighRiskMedShow)
    {
      this.cqmsVisitNoteRiskC2.measureId =0;
    }

    //....




    this.cqmsVisitNoteObjTobacco1.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjTobacco1.encounterId = this.newencId;
    this.cqmsVisitNoteObjTobacco1.isActive = true;
    this.cqmsVisitNoteObjTobacco1.createdBy = "";
    this.cqmsVisitNoteObjTobacco1.measureId = this.TabacooC1List.length > 0 ? this.TabacooC1List[0].cqmsMeasureId : 0;
    //     this.cqmsVisitNoteObjTobacco1.qualifyingDescription = this.visitNoteCQMSForm.value.TabacooCriteria1Screen;
    //     this.cqmsVisitNoteObjTobacco1.Notes = this.visitNoteCQMSForm.value.TabacooCriteria1ScreenNotes;

    // ....

    this.cqmsVisitNoteObjTobacco1.qualifyingDescription = "";
    this.cqmsVisitNoteObjTobacco1.qualifyingCode = 0;
    this.cqmsVisitNoteObjTobacco1.Notes = ""
    if (this.visitNoteCQMSForm.value.TabacooCriteria1Screen) {
      id = this.visitNoteCQMSForm.value.TabacooCriteria1Screen.toString();
      this.cqmsVisitNoteObjTobacco1.qualifyingCode = Number(id);
      res = this.TabacooC1List.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjTobacco1.qualifyingCode);
      this.cqmsVisitNoteObjTobacco1.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';


      this.cqmsVisitNoteObjTobacco1.Notes = this.visitNoteCQMSForm.value.TabacooCriteria1ScreenNotes.toString();
    }
    if(!this.isTabaccoShow1){
      this.cqmsVisitNoteObjTobacco1.measureId =0;
    }

    //  ....





    this.cqmsVisitNoteObjTobacco2.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjTobacco2.encounterId = this.newencId;
    this.cqmsVisitNoteObjTobacco2.isActive = true;
    this.cqmsVisitNoteObjTobacco2.createdBy = "";
    this.cqmsVisitNoteObjTobacco2.measureId = this.TabacooC2List.length > 0 ? this.TabacooC2List[0].cqmsMeasureId : 0;
    //this.cqmsVisitNoteObjTobacco2.qualifyingDescription = this.visitNoteCQMSForm.value.TabacooCriteria2Screen;
    // this.cqmsVisitNoteObjTobacco2.Notes = this.visitNoteCQMSForm.value.TabacooCriteria2ScreenNotes;


    this.cqmsVisitNoteObjTobacco2.qualifyingDescription = "";
    this.cqmsVisitNoteObjTobacco2.qualifyingCode = 0;
    this.cqmsVisitNoteObjTobacco2.Notes = ""
    if (this.visitNoteCQMSForm.value.TabacooCriteria2Screen) {
      id = this.visitNoteCQMSForm.value.TabacooCriteria2Screen.toString();
      this.cqmsVisitNoteObjTobacco2.qualifyingCode = Number(id);
      res = this.TabacooC2List.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjTobacco2.qualifyingCode);
      this.cqmsVisitNoteObjTobacco2.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';


      this.cqmsVisitNoteObjTobacco2.Notes = this.visitNoteCQMSForm.value.TabacooCriteria2ScreenNotes.toString();
    }
    if(!this.isTabaccoShow2){
      this.cqmsVisitNoteObjTobacco2.measureId =0;
    }


    this.cqmsVisitNoteObjTobacco3.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjTobacco3.encounterId = this.newencId;
    this.cqmsVisitNoteObjTobacco3.isActive = true;
    this.cqmsVisitNoteObjTobacco3.createdBy = "";
    this.cqmsVisitNoteObjTobacco3.measureId = this.TabacooC3List.length > 0 ? this.TabacooC3List[0].cqmsMeasureId : 0;
    //  this.cqmsVisitNoteObjTobacco3.qualifyingDescription = this.visitNoteCQMSForm.value.TabacooCriteria3Screen;
    //this.cqmsVisitNoteObjTobacco3.Notes = this.visitNoteCQMSForm.value.TabacooCriteria3ScreenNotes;


    this.cqmsVisitNoteObjTobacco3.qualifyingDescription = "";
    this.cqmsVisitNoteObjTobacco3.qualifyingCode = 0;
    this.cqmsVisitNoteObjTobacco3.Notes = ""
    if (this.visitNoteCQMSForm.value.TabacooCriteria3Screen) {
      id = this.visitNoteCQMSForm.value.TabacooCriteria3Screen.toString();
      this.cqmsVisitNoteObjTobacco3.qualifyingCode = Number(id);
      res = this.TabacooC3List.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjTobacco3.qualifyingCode);
      this.cqmsVisitNoteObjTobacco3.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';


      this.cqmsVisitNoteObjTobacco3.Notes = this.visitNoteCQMSForm.value.TabacooCriteria3ScreenNotes.toString();
    }
    if(!this.isTabaccoShow3){
      this.cqmsVisitNoteObjTobacco3.measureId = 0;
    }


    this.cqmsVisitNoteObjAlcohol1.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjAlcohol1.encounterId = this.newencId;
    this.cqmsVisitNoteObjAlcohol1.isActive = true;
    this.cqmsVisitNoteObjAlcohol1.createdBy = "";
    this.cqmsVisitNoteObjAlcohol1.measureId = this.AlcoholUseC1List.length > 0 ? this.AlcoholUseC1List[0].cqmsMeasureId : 0;
    this.cqmsVisitNoteObjAlcohol1.qualifyingDescription = "";
    this.cqmsVisitNoteObjAlcohol1.qualifyingCode = 0;
    this.cqmsVisitNoteObjAlcohol1.Notes = "";
    if (this.visitNoteCQMSForm.value.AlcoholUseCriteria1Screen) {
      id = this.visitNoteCQMSForm.value.AlcoholUseCriteria1Screen.toString();
      this.cqmsVisitNoteObjAlcohol1.qualifyingCode = Number(id);
      res = this.AlcoholUseC1List.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjAlcohol1.qualifyingCode);
      this.cqmsVisitNoteObjAlcohol1.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';
      this.cqmsVisitNoteObjAlcohol1.Notes = this.visitNoteCQMSForm.value.AlcoholUseCriteria1ScreenNotes.toString();
    }
    if (!this.isAlcoholUseShow1) {
      this.cqmsVisitNoteObjAlcohol1.measureId = 0;
    }

    this.cqmsVisitNoteObjAlcohol2.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjAlcohol2.encounterId = this.newencId;
    this.cqmsVisitNoteObjAlcohol2.isActive = true;
    this.cqmsVisitNoteObjAlcohol2.createdBy = "";
    this.cqmsVisitNoteObjAlcohol2.measureId = this.AlcoholUseC2List.length > 0 ? this.AlcoholUseC2List[0].cqmsMeasureId : 0;
    this.cqmsVisitNoteObjAlcohol2.qualifyingDescription = "";
    this.cqmsVisitNoteObjAlcohol2.qualifyingCode = 0;
    this.cqmsVisitNoteObjAlcohol2.Notes = "";
    if (this.visitNoteCQMSForm.value.AlcoholUseCriteria2Screen) {
      id = this.visitNoteCQMSForm.value.AlcoholUseCriteria2Screen.toString();
      this.cqmsVisitNoteObjAlcohol2.qualifyingCode = Number(id);
      res = this.AlcoholUseC2List.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjAlcohol2.qualifyingCode);
      this.cqmsVisitNoteObjAlcohol2.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';
      this.cqmsVisitNoteObjAlcohol2.Notes = this.visitNoteCQMSForm.value.AlcoholUseCriteria2ScreenNotes.toString();
    }
    if (!this.isAlcoholUseShow2) {
      this.cqmsVisitNoteObjAlcohol2.measureId = 0;
    }

    this.cqmsVisitNoteObjAlcohol3.patId = CommonComponents.patientId;
    this.cqmsVisitNoteObjAlcohol3.encounterId = this.newencId;
    this.cqmsVisitNoteObjAlcohol3.isActive = true;
    this.cqmsVisitNoteObjAlcohol3.createdBy = "";
    this.cqmsVisitNoteObjAlcohol3.measureId = this.AlcoholUseC3List.length > 0 ? this.AlcoholUseC3List[0].cqmsMeasureId : 0;
    this.cqmsVisitNoteObjAlcohol3.qualifyingDescription = "";
    this.cqmsVisitNoteObjAlcohol3.qualifyingCode = 0;
    this.cqmsVisitNoteObjAlcohol3.Notes = "";
    if (this.visitNoteCQMSForm.value.AlcoholUseCriteria3Screen) {
      id = this.visitNoteCQMSForm.value.AlcoholUseCriteria3Screen.toString();
      this.cqmsVisitNoteObjAlcohol3.qualifyingCode = Number(id);
      res = this.AlcoholUseC3List.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteObjAlcohol3.qualifyingCode);
      this.cqmsVisitNoteObjAlcohol3.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';
      this.cqmsVisitNoteObjAlcohol3.Notes = this.visitNoteCQMSForm.value.AlcoholUseCriteria3ScreenNotes.toString();
    }
    if (!this.isAlcoholUseShow3) {
      this.cqmsVisitNoteObjAlcohol3.measureId = 0;
    }


    this.cqmsVisitNoteBMI.patId = CommonComponents.patientId;
    this.cqmsVisitNoteBMI.encounterId = this.newencId //CommonComponents.encounterId;
    this.cqmsVisitNoteBMI.isActive = true;
    this.cqmsVisitNoteBMI.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.cqmsVisitNoteBMI.measureId = this.bmiNewScreenList.length > 0 ? this.bmiNewScreenList[0].cqmsMeasureId : 0;
    // if (this.isbmiChange) {
    // this.cqmsVisitNoteBMI.qualifyingDescription = this.visitNoteCQMSForm.value.bmiScreen;
    // }
    // this.cqmsVisitNoteBMI.Notes = this.visitNoteCQMSForm.value.bmiScreenNotes;

    this.cqmsVisitNoteBMI.qualifyingDescription = "";
    this.cqmsVisitNoteBMI.qualifyingCode = 0;
    this.cqmsVisitNoteBMI.Notes = ""
    if (this.visitNoteCQMSForm.value.bmiScreen) {
      id = this.visitNoteCQMSForm.value.bmiScreen.toString();
      this.cqmsVisitNoteBMI.qualifyingCode = Number(id);
      res = this.bmiNewScreenList.filter((item: any) => item.qualifyingCodeId == this.cqmsVisitNoteBMI.qualifyingCode);
      this.cqmsVisitNoteBMI.qualifyingDescription = res.length > 0 ? res[0].qualifyMeasureName : '';


      this.cqmsVisitNoteBMI.Notes = this.visitNoteCQMSForm.value.bmiScreenNotes.toString();
    }
    if(!this.isbmiShow){
      this.cqmsVisitNoteBMI.measureId = 0;
    }


    // this.cqmsVisitNoteObj6.patId = CommonComponents.patientId;
    // this.cqmsVisitNoteObj6.encounterId = this.newencId //CommonComponents.encounterId;
    // this.cqmsVisitNoteObj6.isActive = true;
    // this.cqmsVisitNoteObj6.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    // this.cqmsVisitNoteObj6.measureId = this.opioidTherapy.length > 0 ? this.opioidTherapy[0].cqmsMeasureId : 0;
    // if (this.isOpioidChange) {
    //   this.cqmsVisitNoteObj6.qualifyingDescription = this.visitNoteCQMSForm.value.opioidTherapyScreen;
    // }
    // this.cqmsVisitNoteObj7.patId = CommonComponents.patientId;
    // this.cqmsVisitNoteObj7.encounterId = this.newencId //CommonComponents.encounterId;
    // this.cqmsVisitNoteObj7.isActive = true;
    // this.cqmsVisitNoteObj7.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    // this.cqmsVisitNoteObj7.measureId = this.documentationSignList.length > 0 ? this.documentationSignList[0].cqmsMeasureId : 0;
    // if (this.isDocSignChange) {
    //   this.cqmsVisitNoteObj7.qualifyingDescription = this.visitNoteCQMSForm.value.documentationSignedScreen;
    // }
    // this.cqmsVisitNoteObj8.patId = CommonComponents.patientId;
    // this.cqmsVisitNoteObj8.encounterId = this.newencId //CommonComponents.encounterId;
    // this.cqmsVisitNoteObj8.isActive = true;
    // this.cqmsVisitNoteObj8.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    // this.cqmsVisitNoteObj8.measureId = this.evaluationOrInterviewList.length > 0 ? this.evaluationOrInterviewList[0].cqmsMeasureId : 0;
    // if (this.isEvaluationChange) {
    //   this.cqmsVisitNoteObj8.qualifyingDescription = this.visitNoteCQMSForm.value.evaluationInterviewScreen;
    // }


  }

  async saveVisitNoteInfo(encId: any) {
    try {
      this.spinner.show();

      if (encId == '0') {
        this.isnewencounter = false;
        this.newencId = CommonComponents.encounterId;
      } else {
        this.newencId = encId;
        this.isnewencounter = true;
      }
      this.cqmsMainObject = [];
      this.createObjects();
      this.cqmsMainObject.push(this.cqmsVisitNoteObjAdvanceCare)
      this.cqmsMainObject.push(this.cqmsVisitNoteObjOsteoporosis)
      this.cqmsMainObject.push(this.cqmsVisitNoteObjPneumococcal)

      this.cqmsMainObject.push(this.cqmsVisitNoteBMI)
      this.cqmsMainObject.push(this.cqmsVisitNoteObjDocCurMed)
      // this.cqmsMainObject.push(this.cqmsVisitNoteObj6)
      // this.cqmsMainObject.push(this.cqmsVisitNoteObj7)
      // this.cqmsMainObject.push(this.cqmsVisitNoteObj8)
      this.cqmsMainObject.push(this.cqmsVisitNoteObjHighRiskMed1)
      this.cqmsMainObject.push(this.cqmsVisitNoteRiskC2)
      this.cqmsMainObject.push(this.cqmsVisitNoteObjCLR)
      this.cqmsMainObject.push(this.cqmsVisitNoteObjTobacco1)
      this.cqmsMainObject.push(this.cqmsVisitNoteObjTobacco2)
      this.cqmsMainObject.push(this.cqmsVisitNoteObjTobacco3)
      this.cqmsMainObject.push(this.cqmsVisitNoteObjAlcohol1)
      this.cqmsMainObject.push(this.cqmsVisitNoteObjAlcohol2)
      this.cqmsMainObject.push(this.cqmsVisitNoteObjAlcohol3)
      this.cqmsMainObject.push(this.cqmsVisitNoteObjDepression)

      await this.cqmsConfigurationService.InsertUpdateCQMSVisitNoteDetails(this.cqmsMainObject).subscribe(
        results => {
          this.result = results;
          if (this.isnewencounter == false) {
            this.toastr.success(this.result);
            this.onCQMSCancel();

          }
          //  this.clearDropdownValues();
          this.getVisitNoteFlags();
          this.getVisitNoteInfo();
          this.spinner.hide();
        },
        Error => {
          this.spinner.hide();
        }
      )
        ;
    }
    catch (ex) {
      this.spinner.hide();

    }
  }

  getVisitNoteInfo() {
    this.encounterId = CommonComponents.encounterId;
    //  alert(this.encounterId)
    if (this.encounterId != "null" && this.encounterId != undefined) {
      this.cqmsConfigurationService.GetCQMSVisitNoteInfo(this.encounterId).subscribe(data => {
        if (data != null && data != undefined) {

          this.cqmsVisitNoteList = data;
          this.bindCqmsLoadData();
          // this.autoCompleteValueBind();
        }

      })
    }
  }
  bindCqmsLoadData() {
    if (this.cqmsVisitNoteList.length > 0) {

      //Advance Care Plan      this.cqmsVisitNoteObjAdvanceCare.cqmsVisitId = this.cqmsVisitNoteList[0].cqmsVisitId; //  advanceCare
      let obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Advance Care Plan')
      if (obj && obj.length > 0) {
        this.cqmsVisitNoteObjAdvanceCare.measureId = obj[0].measureId;
        this.cqmsVisitNoteObjAdvanceCare.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteObjAdvanceCare.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteObjAdvanceCare.isPerfomanceMed = obj[0].isPerfomanceMed;
        this.cqmsVisitNoteObjAdvanceCare.Notes = obj[0].Notes;
        this.visitNoteCQMSForm.patchValue({
          advanceCarePlan: this.flagsList[0].isAdvanceCare && this.flagsList[0].advanceDesc ? this.flagsList[0].advanceDesc.split(':')[0] : obj[0].qualifyingCode.toString(),
          //this.cqmsVisitNoteObjAdvanceCare.qualifyingCode
        });
      }else{
        this.visitNoteCQMSForm.patchValue({
          advanceCarePlan: this.flagsList[0].isAdvanceCare && this.flagsList[0].advanceDesc ? this.flagsList[0].advanceDesc.split(':')[0] : "",
          //this.cqmsVisitNoteObjAdvanceCare.qualifyingCode
        });
      }

      // Osteoporosis Screening
      let objOsteo = this.cqmsVisitNoteList.filter(item => item.measureName == 'Screening for Osteoporosis for Women Aged 65-85 Years of Age');
      if (objOsteo && objOsteo.length > 0) {
        this.cqmsVisitNoteObjOsteoporosis.measureId = objOsteo[0].measureId;
        this.cqmsVisitNoteObjOsteoporosis.qualifyingCode = objOsteo[0].qualifyingCode;
        this.cqmsVisitNoteObjOsteoporosis.qualifyingDescription = objOsteo[0].qualifyingDescription;
        this.cqmsVisitNoteObjOsteoporosis.isPerfomanceMed = objOsteo[0].isPerfomanceMed;
        this.cqmsVisitNoteObjOsteoporosis.Notes = objOsteo[0].Notes;
        this.visitNoteCQMSForm.patchValue({
          osteoporosisScreen: this.flagsList[0].IsOsteoporosis && this.flagsList[0].OsteoporosisDesc ? Number(this.flagsList[0].OsteoporosisDesc.split(':')[0]) : Number(objOsteo[0].qualifyingCode)
        });
      } else {
        this.visitNoteCQMSForm.patchValue({
          osteoporosisScreen: this.flagsList[0].IsOsteoporosis && this.flagsList[0].OsteoporosisDesc ? Number(this.flagsList[0].OsteoporosisDesc.split(':')[0]) : ''
        });
      }

      // Depression Screening and Follow-Up Plan (Quality ID #134)
      // Primary source is the saved CQMS_VISITNOTE_DETAILS row (this panel's own Save button), same as
      // the other measures above. When that doesn't exist, fall back to flagsList (populated from the
      // Visit Note > Discussions > "26E.Screening for Depression and Follow-Up Plan" selection) instead
      // of unconditionally clearing the field, so this fallback doesn't clobber what getVisitNoteFlags()
      // already patched in.
      let objDepression = this.cqmsVisitNoteList.filter(item => item.measureName == 'Preventive Care and Screening: Screening for Depression and Follow-Up Plan');
      if (objDepression && objDepression.length > 0) {
        this.cqmsVisitNoteObjDepression.measureId = objDepression[0].measureId;
        this.cqmsVisitNoteObjDepression.qualifyingCode = objDepression[0].qualifyingCode;
        this.cqmsVisitNoteObjDepression.qualifyingDescription = objDepression[0].qualifyingDescription;
        this.cqmsVisitNoteObjDepression.isPerfomanceMed = objDepression[0].isPerfomanceMed;
        this.cqmsVisitNoteObjDepression.Notes = objDepression[0].Notes;
        this.DepressionDesc = objDepression[0].qualifyingDescription;
        this.isDepressionCrossOrRight = objDepression[0].isPerfomanceMed;
        this.encDepressionDate = objDepression[0].modifiedOn ? objDepression[0].modifiedOn : objDepression[0].createdOn;
        this.visitNoteCQMSForm.patchValue({
          depressionScreen: objDepression[0].qualifyingCode,
          depressionScreenNotes: objDepression[0].Notes
        });
      } else if (this.flagsList[0] && this.flagsList[0].Depression && this.flagsList[0].DepressionDesc) {
        this.isDepressionCrossOrRight = true;
        this.visitNoteCQMSForm.patchValue({
          depressionScreen: this.flagsList[0].DepressionDesc.split(':')[0]
        });
      } else {
        this.DepressionDesc = '';
        this.visitNoteCQMSForm.patchValue({
          depressionScreen: '',
          depressionScreenNotes: ''
        });
      }

      //'Pneumococcal Vaccination Status  this.cqmsVisitNoteObj2.cqmsVisitId = this.cqmsVisitNoteList[1].cqmsVisitId; // pneuomical
       obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Pneumococcal Vaccination Status for Older Adults')
      if (obj && obj.length > 0) {
        this.cqmsVisitNoteObjPneumococcal.measureId = obj[0].measureId;
        this.cqmsVisitNoteObjPneumococcal.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteObjPneumococcal.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteObjPneumococcal.isPerfomanceMed = obj[0].isPerfomanceMed;
        // this.visitNoteCQMSForm.patchValue({
        //   pneumococcal: obj[0].qualifyingDescription
        // });
        //_doccurmedscreen=  this.flagsList[0].isDocCurrentMed && this.flagsList[0].docCurrentMedDesc ? this.flagsList[0].docCurrentMedDesc.split(':')[0]:obj[0].qualifyingCode 

        this.visitNoteCQMSForm.patchValue({

          pneumococcal: this.flagsList[0].isPneumococcal && this.flagsList[0].pneumococcalDesc ? this.flagsList[0].pneumococcalDesc.split(':')[0] : obj[0].qualifyingCode,
          pneumococcalNotes: obj[0].Notes
        });
      }
      else {
        this.visitNoteCQMSForm.patchValue({

          pneumococcal: this.flagsList[0].isPneumococcal && this.flagsList[0].pneumococcalDesc ? this.flagsList[0].pneumococcalDesc.split(':')[0] : "",
          pneumococcalNotes: ""
        });
      }




      //this.cqmsVisitNoteObj3.cqmsVisitId = this.cqmsVisitNoteList[9].cqmsVisitId; 
      // high risk med (cre-2)
      obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Use of High-Risk Medications in the Elderly (Criteria Two)')
      if (obj && obj.length > 0) {
        this.cqmsVisitNoteRiskC2.measureId = obj[0].measureId;
        this.cqmsVisitNoteRiskC2.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteRiskC2.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteRiskC2.isPerfomanceMed = obj[0].isPerfomanceMed;
        this.visitNoteCQMSForm.patchValue({
          highRiskCriteriaTwo: obj[0].qualifyingDescription,
          highRiskCriteriaTwoNotes: obj[0].Notes
        });
      }

      //this.cqmsVisitNoteObj4.cqmsVisitId = this.cqmsVisitNoteList[7].cqmsVisitId; 
      // BMI
      obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Preventive Care and Screening: Body Mass Index (BMI) Screening and Follow-Up Plan')
      if (obj && obj.length > 0) {
        this.cqmsVisitNoteBMI.measureId = obj[0].measureId;
        this.cqmsVisitNoteBMI.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteBMI.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteBMI.isPerfomanceMed = obj[0].isPerfomanceMed;
        // this.visitNoteCQMSForm.patchValue({
        //   bmiScreen: obj[0].qualifyingDescription
        // });
        this.visitNoteCQMSForm.patchValue({

          bmiScreen: this.flagsList[0].isBMI && this.flagsList[0].bmiQualifyDesc ? this.flagsList[0].bmiQualifyDesc.split(':')[0] : obj[0].qualifyingCode,
          bmiScreenNotes: obj[0].Notes
        });
      }
      else {
        this.visitNoteCQMSForm.patchValue({

          bmiScreen: this.flagsList[0].isBMI && this.flagsList[0].bmiQualifyDesc ? this.flagsList[0].bmiQualifyDesc.split(':')[0] : ""
          , bmiScreenNotes: ""
        });
      }
      //  this.cqmsVisitNoteObj5.cqmsVisitId = this.cqmsVisitNoteList[2].cqmsVisitId;   
      // doc of currnt med
      obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Documentation of Current Medications in the Medical Record')

      if (obj && obj.length > 0) {
        //alert('fired');
        this.cqmsVisitNoteObjDocCurMed.measureId = obj[0].measureId;
        this.cqmsVisitNoteObjDocCurMed.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteObjDocCurMed.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteObjDocCurMed.isPerfomanceMed = obj[0].isPerfomanceMed;
        //alert(obj[0].qualifyingCode)
        //_doccurmedscreen=  this.flagsList[0].isDocCurrentMed && this.flagsList[0].docCurrentMedDesc ? this.flagsList[0].docCurrentMedDesc.split(':')[0]:obj[0].qualifyingCode 

        this.visitNoteCQMSForm.patchValue({

          docCurrentMedScreen: this.flagsList[0].isDocCurrentMed && this.flagsList[0].docCurrentMedDesc ? this.flagsList[0].docCurrentMedDesc.split(':')[0] : obj[0].qualifyingCode,
          docCurrentMedScreenNotes: obj[0].Notes
        });
      }
      else {
        this.visitNoteCQMSForm.patchValue({

          docCurrentMedScreen: this.flagsList[0].isDocCurrentMed && this.flagsList[0].docCurrentMedDesc ? this.flagsList[0].docCurrentMedDesc.split(':')[0] : "",
          docCurrentMedScreenNotes: ""
        });
      }

      //(CRITERIA 1) Preventive Care and Screening: Tobacco Use: Screening and Cessation Intervention (CRITERIA 1)
      obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Preventive Care and Screening: Tobacco Use: Screening and Cessation Intervention (CRITERIA 1)')

      if (obj && obj.length > 0) {
        //alert('fired');
        this.cqmsVisitNoteObjTobacco1.measureId = obj[0].measureId;
        this.cqmsVisitNoteObjTobacco1.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteObjTobacco1.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteObjTobacco1.isPerfomanceMed = obj[0].isPerfomanceMed;
        //alert(obj[0].qualifyingCode)
        //_doccurmedscreen=  this.flagsList[0].isDocCurrentMed && this.flagsList[0].docCurrentMedDesc ? this.flagsList[0].docCurrentMedDesc.split(':')[0]:obj[0].qualifyingCode 

        this.visitNoteCQMSForm.patchValue({

          TabacooCriteria1Screen: this.flagsList[0].isTabaccoShow1 && this.flagsList[0].Tabacco1QualifyDesc ? this.flagsList[0].Tabacco1QualifyDesc.split(':')[0] : obj[0].qualifyingCode
          , TabacooCriteria1ScreenNotes: obj[0].Notes
        });
      }
      else {
        this.visitNoteCQMSForm.patchValue({

          TabacooCriteria1Screen: this.flagsList[0].isTabaccoShow1 && this.flagsList[0].Tabacco1QualifyDesc ? this.flagsList[0].Tabacco1QualifyDesc.split(':')[0] : ""
          , TabacooCriteria1ScreenNotes: ""
        });
      }
      ///(CRITERIA 2) Preventive Care and Screening: Tobacco Use: Screening and Cessation Intervention (CRITERIA 2)
      // this.cqmsVisitNoteObj6.cqmsVisitId = this.cqmsVisitNoteList[3].cqmsVisitId;   //  opid ther
      obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Preventive Care and Screening: Tobacco Use: Screening and Cessation Intervention (CRITERIA 2)')

      if (obj && obj.length > 0) {
        //alert('fired');
        this.cqmsVisitNoteObjTobacco2.measureId = obj[0].measureId;
        this.cqmsVisitNoteObjTobacco2.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteObjTobacco2.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteObjTobacco2.isPerfomanceMed = obj[0].isPerfomanceMed;
        //alert(obj[0].qualifyingCode)
        //_doccurmedscreen=  this.flagsList[0].isDocCurrentMed && this.flagsList[0].docCurrentMedDesc ? this.flagsList[0].docCurrentMedDesc.split(':')[0]:obj[0].qualifyingCode 

        this.visitNoteCQMSForm.patchValue({

          TabacooCriteria2Screen: this.flagsList[0].isTabaccoShow2 && this.flagsList[0].Tabacco2QualifyDesc ? this.flagsList[0].Tabacco2QualifyDesc.split(':')[0] : obj[0].qualifyingCode
          , TabacooCriteria2ScreenNotes: obj[0].Notes
        });
      }
      else {
        this.visitNoteCQMSForm.patchValue({

          TabacooCriteria2Screen: this.flagsList[0].isTabaccoShow2 && this.flagsList[0].Tabacco2QualifyDesc ? this.flagsList[0].Tabacco2QualifyDesc.split(':')[0] : ""
          , TabacooCriteria2ScreenNotes: ""
        });
      }

      ///(CRITERIA 3) Preventive Care and Screening: Tobacco Use: Screening and Cessation Intervention (CRITERIA 2)
      // this.cqmsVisitNoteObj6.cqmsVisitId = this.cqmsVisitNoteList[3].cqmsVisitId;   //  opid ther
      obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Preventive Care and Screening: Tobacco Use: Screening and Cessation Intervention (CRITERIA 3)')

      if (obj && obj.length > 0) {
        //alert('fired');
        this.cqmsVisitNoteObjTobacco3.measureId = obj[0].measureId;
        this.cqmsVisitNoteObjTobacco3.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteObjTobacco3.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteObjTobacco3.isPerfomanceMed = obj[0].isPerfomanceMed;
        //alert(obj[0].qualifyingCode)
        //_doccurmedscreen=  this.flagsList[0].isDocCurrentMed && this.flagsList[0].docCurrentMedDesc ? this.flagsList[0].docCurrentMedDesc.split(':')[0]:obj[0].qualifyingCode 

        this.visitNoteCQMSForm.patchValue({

          TabacooCriteria3Screen: this.flagsList[0].isTabaccoShow3 && this.flagsList[0].Tabacco3QualifyDesc ? this.flagsList[0].Tabacco3QualifyDesc.split(':')[0] : obj[0].qualifyingCode
          , TabacooCriteria3ScreenNotes: obj[0].Notes
        });
      }
      else {
        this.visitNoteCQMSForm.patchValue({

          TabacooCriteria3Screen: this.flagsList[0].isTabaccoShow3 && this.flagsList[0].Tabacco3QualifyDesc ? this.flagsList[0].Tabacco3QualifyDesc.split(':')[0] : ""
          , TabacooCriteria3ScreenNotes: ""
        });
      }

      // Alcohol Use Screening (CRITERIA 1)
      obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Screening of Unhealthy Alcohol Use (Criteria 1)')
      if (obj && obj.length > 0) {
        this.cqmsVisitNoteObjAlcohol1.measureId = obj[0].measureId;
        this.cqmsVisitNoteObjAlcohol1.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteObjAlcohol1.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteObjAlcohol1.isPerfomanceMed = obj[0].isPerfomanceMed;
        this.visitNoteCQMSForm.patchValue({
          AlcoholUseCriteria1Screen: this.flagsList[0].isAlcoholUseShow1 && this.flagsList[0].AlcoholUse1QualifyDesc ? this.flagsList[0].AlcoholUse1QualifyDesc.split(':')[0] : obj[0].qualifyingCode
          , AlcoholUseCriteria1ScreenNotes: obj[0].Notes
        });
      } else {
        this.visitNoteCQMSForm.patchValue({
          AlcoholUseCriteria1Screen: this.flagsList[0].isAlcoholUseShow1 && this.flagsList[0].AlcoholUse1QualifyDesc ? this.flagsList[0].AlcoholUse1QualifyDesc.split(':')[0] : ""
          , AlcoholUseCriteria1ScreenNotes: ""
        });
      }

      // Alcohol Use Screening (CRITERIA 2)
      obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Screening of Unhealthy Alcohol Use (Criteria 2)')
      if (obj && obj.length > 0) {
        this.cqmsVisitNoteObjAlcohol2.measureId = obj[0].measureId;
        this.cqmsVisitNoteObjAlcohol2.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteObjAlcohol2.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteObjAlcohol2.isPerfomanceMed = obj[0].isPerfomanceMed;
        this.visitNoteCQMSForm.patchValue({
          AlcoholUseCriteria2Screen: this.flagsList[0].isAlcoholUseShow2 && this.flagsList[0].AlcoholUse2QualifyDesc ? this.flagsList[0].AlcoholUse2QualifyDesc.split(':')[0] : obj[0].qualifyingCode
          , AlcoholUseCriteria2ScreenNotes: obj[0].Notes
        });
      } else {
        this.visitNoteCQMSForm.patchValue({
          AlcoholUseCriteria2Screen: this.flagsList[0].isAlcoholUseShow2 && this.flagsList[0].AlcoholUse2QualifyDesc ? this.flagsList[0].AlcoholUse2QualifyDesc.split(':')[0] : ""
          , AlcoholUseCriteria2ScreenNotes: ""
        });
      }

      // Alcohol Use Screening (CRITERIA 3)
      obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Screening of Unhealthy Alcohol Use (Criteria 3)')
      if (obj && obj.length > 0) {
        this.cqmsVisitNoteObjAlcohol3.measureId = obj[0].measureId;
        this.cqmsVisitNoteObjAlcohol3.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteObjAlcohol3.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteObjAlcohol3.isPerfomanceMed = obj[0].isPerfomanceMed;
        this.visitNoteCQMSForm.patchValue({
          AlcoholUseCriteria3Screen: this.flagsList[0].isAlcoholUseShow3 && this.flagsList[0].AlcoholUse3QualifyDesc ? this.flagsList[0].AlcoholUse3QualifyDesc.split(':')[0] : obj[0].qualifyingCode
          , AlcoholUseCriteria3ScreenNotes: obj[0].Notes
        });
      } else {
        this.visitNoteCQMSForm.patchValue({
          AlcoholUseCriteria3Screen: this.flagsList[0].isAlcoholUseShow3 && this.flagsList[0].AlcoholUse3QualifyDesc ? this.flagsList[0].AlcoholUse3QualifyDesc.split(':')[0] : ""
          , AlcoholUseCriteria3ScreenNotes: ""
        });
      }

      // #region "waste"

      // //Opioid Therapy Follow-up Evaluation
      // obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Opioid Therapy Follow-up Evaluation')
      // if (obj && obj.length > 0) {
      //   this.cqmsVisitNoteObj6.measureId = obj[0].measureId;
      //   this.cqmsVisitNoteObj6.qualifyingCode = obj[0].qualifyingCode;
      //   this.cqmsVisitNoteObj6.qualifyingDescription = obj[0].qualifyingDescription;
      //   this.cqmsVisitNoteObj6.isPerfomanceMed = obj[0].isPerfomanceMed;
      //   this.visitNoteCQMSForm.patchValue({
      //     opioidTherapyScreen: obj[0].qualifyingDescription
      //   });
      // }


      // // this.cqmsVisitNoteObj7.cqmsVisitId = this.cqmsVisitNoteList[4].cqmsVisitId;  
      // // doc sign
      // obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Documentation of Signed Opioid Treatment Agreement')
      // if (obj && obj.length > 0) {
      //   this.cqmsVisitNoteObj7.measureId = obj[0].measureId;
      //   this.cqmsVisitNoteObj7.qualifyingCode = obj[0].qualifyingCode;
      //   this.cqmsVisitNoteObj7.qualifyingDescription = obj[0].qualifyingDescription;
      //   this.cqmsVisitNoteObj7.isPerfomanceMed = obj[0].isPerfomanceMed;
      //   this.visitNoteCQMSForm.patchValue({
      //     documentationSignedScreen: obj[0].qualifyingDescription
      //   });
      // }
      // // evaluation ot Interview // this.cqmsVisitNoteObj8.cqmsVisitId = this.cqmsVisitNoteList[5].cqmsVisitId; 
      // obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Evaluation or Interview for Risk of Opioid Misuse')
      // if (obj && obj.length > 0) {
      //   this.cqmsVisitNoteObj8.measureId = obj[0].measureId;
      //   this.cqmsVisitNoteObj8.qualifyingCode = obj[0].qualifyingCode;
      //   this.cqmsVisitNoteObj8.qualifyingDescription = obj[0].qualifyingDescription;
      //   this.cqmsVisitNoteObj8.isPerfomanceMed = obj[0].isPerfomanceMed;
      //   this.visitNoteCQMSForm.patchValue({
      //     evaluationInterviewScreen: obj[0].qualifyingDescription
      //   });
      // }

      //this.cqmsVisitNoteObj9.cqmsVisitId = this.cqmsVisitNoteList[6].cqmsVisitId;  
      //  #endregion


      // #region high risk med  (cre-1)
      obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Use of High-Risk Medications in the Elderly (Criteria One)')
      if (obj && obj.length > 0) {
        this.cqmsVisitNoteObjHighRiskMed1.measureId = obj[0].measureId;
        this.cqmsVisitNoteObjHighRiskMed1.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteObjHighRiskMed1.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteObjHighRiskMed1.isPerfomanceMed = obj[0].isPerfomanceMed;
        // this.visitNoteCQMSForm.patchValue({
        //   highRiskMedScreen: obj[0].qualifyingDescription
        // });
        this.visitNoteCQMSForm.patchValue({

          highRiskMedScreen: this.flagsList[0].isHighRiskMed && this.flagsList[0].highRiskMedDesc ? this.flagsList[0].highRiskMedDesc.split(':')[0] : obj[0].qualifyingCode
          , highRiskMedScreenNotes: obj[0].Notes
        });
      }
      else {
        this.visitNoteCQMSForm.patchValue({

          highRiskMedScreen: this.flagsList[0].isHighRiskMed && this.flagsList[0].highRiskMedDesc ? this.flagsList[0].highRiskMedDesc.split(':')[0] : ""
          , highRiskMedScreenNotes: ""
        });
      }

      //#region high risk med  (cre-1)
      // #region high risk med  (cre-1)
      obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Use of High-Risk Medications in the Elderly (Criteria Two)')
      if (obj && obj.length > 0) {
        this.cqmsVisitNoteRiskC2.measureId = obj[0].measureId;
        this.cqmsVisitNoteRiskC2.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteRiskC2.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteRiskC2.isPerfomanceMed = obj[0].isPerfomanceMed;
        // this.visitNoteCQMSForm.patchValue({
        //   highRiskMedScreen: obj[0].qualifyingDescription
        // });

        this.visitNoteCQMSForm.patchValue({

          highRiskCriteriaTwo: this.flagsList[0].isC2HighRiskMed && this.flagsList[0].C2highRiskMedDesc ? this.flagsList[0].C2highRiskMedDesc.split(':')[0] : obj[0].qualifyingCode
          , highRiskMedScreenC2Notes: obj[0].Notes
        });
      }
      else {
        this.visitNoteCQMSForm.patchValue({

          highRiskCriteriaTwo: this.flagsList[0].isC2HighRiskMed && this.flagsList[0].C2highRiskMedDesc ? this.flagsList[0].C2highRiskMedDesc.split(':')[0] : ""
          , highRiskMedScreenC2Notes: ""
        });
      }

      //#region high risk med  (cre-1)
      //Closing the Referral Loop
      obj = this.cqmsVisitNoteList.filter(item => item.measureName == 'Closing the Referral Loop')
      if (obj && obj.length > 0) {
        //  this.cqmsVisitNoteObj10.cqmsVisitId = this.cqmsVisitNoteList[8].cqmsVisitId;
        // alert('fired');

        //this.closeRefId = closeReflist[0].qualifyingCodeId.toString();
        this.cqmsVisitNoteObjCLR.measureId = obj[0].measureId;
        this.cqmsVisitNoteObjCLR.qualifyingCode = obj[0].qualifyingCode;
        this.cqmsVisitNoteObjCLR.qualifyingDescription = obj[0].qualifyingDescription;
        this.cqmsVisitNoteObjCLR.isPerfomanceMed = obj[0].isPerfomanceMed;

        // this.visitNoteCQMSForm.patchValue({
        //   closeRefScreen: obj[0].qualifyingDescription
        // });

        this.visitNoteCQMSForm.patchValue({

          closeRefScreen: this.flagsList[0].isCloseRef && this.flagsList[0].CloseRefDesc ? this.flagsList[0].CloseRefDesc.split(':')[0] : obj[0].qualifyingCode
          , closeRefScreenNotes: obj[0].Notes
        });
      }
      else {
        this.visitNoteCQMSForm.patchValue({

          closeRefScreen: this.flagsList[0].isCloseRef && this.flagsList[0].CloseRefDesc ? this.flagsList[0].CloseRefDesc.split(':')[0] : ""
          , closeRefScreenNotes: ""
        });
      }
      // this.cqmsVisitNoteObj8.measureId = this.cqmsVisitNoteList[5].measureId;
      // this.cqmsVisitNoteObj8.qualifyingCode = this.cqmsVisitNoteList[5].qualifyingCode;
      // this.cqmsVisitNoteObj8.qualifyingDescription = this.cqmsVisitNoteList[5].qualifyingDescription;
      // this.cqmsVisitNoteObj8.isPerfomanceMed = this.cqmsVisitNoteList[5].isPerfomanceMed;



    }
  }
  // autoCompleteValueBind() {
  //   if (this.cqmsVisitNoteList.length > 0) {
  //     if (this.advanceCareList.length > 0) {
  //       if (this.cqmsVisitNoteList[0].qualifyingDescription != null) {
  //         this.visitNoteCQMSForm.patchValue({
  //           advanceCarePlan: this.cqmsVisitNoteList.filter(item=>item.measureName=='').map(element=>element.qualifyingDescription)[0]
  //         });
  //       }
  //     }
  //     if (this.pneumococcalList.length > 0) {
  //       if (this.cqmsVisitNoteList[1].qualifyingDescription != null) {
  //         this.visitNoteCQMSForm.patchValue({
  //           pneumococcal: this.cqmsVisitNoteList[1].qualifyingDescription
  //         });
  //       }
  //     }
  //     if (this.highRiskMedC2List.length > 0) {
  //       if (this.cqmsVisitNoteList[9].qualifyingDescription != null) {
  //         this.visitNoteCQMSForm.patchValue({
  //           highRiskCriteriaTwo: this.cqmsVisitNoteList[9].qualifyingDescription
  //         });
  //       }
  //     }
  //     if (this.bmiScreeningList.length > 0) {
  //       if (this.cqmsVisitNoteList[7].qualifyingDescription != null) {
  //         this.visitNoteCQMSForm.patchValue({
  //           bmiScreen: this.cqmsVisitNoteList[7].qualifyingDescription
  //         });
  //       }
  //     }
  //     if (this.documentationCurentMedList.length > 0) {
  //       if (this.cqmsVisitNoteList[2].qualifyingDescription != null) {
  //         this.visitNoteCQMSForm.patchValue({
  //           docCurrentMedScreen: this.cqmsVisitNoteList[2].qualifyingDescription
  //         });
  //       }
  //     }
  //     if (this.opioidTherapy.length > 0) {
  //       if (this.cqmsVisitNoteList[3].qualifyingDescription != null) {
  //         this.visitNoteCQMSForm.patchValue({
  //           opioidTherapyScreen: this.cqmsVisitNoteList[3].qualifyingDescription
  //         });
  //       }
  //     }
  //     if (this.documentationSignList.length > 0) {
  //       if (this.cqmsVisitNoteList[4].qualifyingDescription != null) {
  //         this.visitNoteCQMSForm.patchValue({
  //           documentationSignedScreen: this.cqmsVisitNoteList[4].qualifyingDescription
  //         });
  //       }
  //     }
  //     if (this.evaluationOrInterviewList.length > 0) {
  //       if (this.cqmsVisitNoteList[5].qualifyingDescription != null) {
  //         this.visitNoteCQMSForm.patchValue({
  //           evaluationInterviewScreen: this.cqmsVisitNoteList[5].qualifyingDescription
  //         });
  //       }
  //     }
  //     if (this.highRiskMedList.length > 0) {
  //       if (this.cqmsVisitNoteList[6].qualifyingDescription != null) {
  //         this.visitNoteCQMSForm.patchValue({
  //           highRiskMedScreen: this.cqmsVisitNoteList[6].qualifyingDescription
  //         });
  //       }
  //     }
  //     if (this.closingRefList.length > 0) {
  //       if (this.cqmsVisitNoteList[8].qualifyingDescription != null) {
  //         this.visitNoteCQMSForm.patchValue({
  //           closeRefScreen: this.cqmsVisitNoteList[8].qualifyingDescription
  //         });
  //       }

  //     }
  //   }
  // }



  //#region Filters


  advanceCarefilter() {
    this.advanceCareOptions = this.visitNoteCQMSForm.get('advanceCarePlan')!.valueChanges.pipe(
      startWith(""),
      map(value => this._advanceCare(value))
    );
  }
  private _advanceCare(value: string): measureQualifyName[] {
    value = !value ? "" : value;
    const filterValue = value.toString().toLowerCase();
    if (this.advanceCareList != undefined) {
      return this.advanceCareList.filter(option => option.qualifyMeasureName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  // pneumococcalfilter() {
  //   this.pneumococcalOptions = this.visitNoteCQMSForm.get('pneumococcal')!.valueChanges.pipe(
  //     startWith(""),
  //     map(value => this._pneumococcal(value))
  //   );
  // }
  // private _pneumococcal(value: string): measureQualifyName[] {
  //   value = !value ? "" : value;
  //   const filterValue = value.toString().toLowerCase();
  //   if (this.pneumococcalList != undefined) {
  //     return this.pneumococcalList.filter(option => option.qualifyMeasureName.toLowerCase().indexOf(filterValue) === 0);
  //   }
  // }

  preventAndScreenfilter() {
    this.preventAndScreenOptions = this.visitNoteCQMSForm.get('preventiveCareScreen')!.valueChanges.pipe(
      startWith(""),
      map(value => this._preventAndScreen(value))
    );
  }
  private _preventAndScreen(value: string): measureQualifyName[] {
    value = !value ? "" : value;
    const filterValue = value.toString().toLowerCase();
    if (this.preventAndScreenList != undefined) {
      return this.preventAndScreenList.filter(option => option.qualifyMeasureName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  // bmiScreeningfilter() {
  //   return;
  //   this.bmiScreenOptions = this.visitNoteCQMSForm.get('bmiScreen')!.valueChanges.pipe(
  //     startWith(""),
  //     map(value => this._bmiScreening(value))
  //   );
  // }
  // private _bmiScreening(value: string): measureQualifyName[] {
  //   value = !value ? "" : value;
  //   const filterValue = value.toString().toLowerCase();
  //   if (this.bmiScreeningList != undefined) {
  //     return this.bmiScreeningList.filter(option => option.qualifyMeasureName.toLowerCase().indexOf(filterValue) === 0);
  //   }
  // }

  // documentCurrentMedfilter() {
  //   this.docCurrentScreenOptions =this._docCurrentMedScreening('');//this.documentationCurentMedList ;
  //   this.visitNoteCQMSForm.get('docCurrentMedScreen')!.valueChanges.pipe(
  //     startWith(""),
  //     map(value => this._docCurrentMedScreening(value))
  //   );
  // }
  //  private _docCurrentMedScreening(value: string): measureQualifyName[] {
  //   value=!value?"":value;
  //   const filterValue = value.toString().toLowerCase();
  //    if (this.documentationCurentMedList != undefined) {
  //     return this.documentationCurentMedList.filter(option => option.qualifyMeasureName.toLowerCase().indexOf(filterValue) === 0 );
  //   }
  // }

  // opioidTherapyfilter() {
  //   this.opioidTherapyScreenOptions = this.visitNoteCQMSForm.get('opioidTherapyScreen')!.valueChanges.pipe(
  //     startWith(""),
  //     map(value => this._opioidTherapyScreening(value))
  //   );
  // }
  // private _opioidTherapyScreening(value: string): measureQualifyName[] {
  //   value = !value ? "" : value;
  //   const filterValue = value.toString().toLowerCase();
  //   if (this.opioidTherapy != undefined) {
  //     return this.opioidTherapy.filter(option => option.qualifyMeasureName.toLowerCase().indexOf(filterValue) === 0);
  //   }
  // }

  // documentationSignedfilter() {
  //   this.documentationSignScreenOptions = this.visitNoteCQMSForm.get('documentationSignedScreen')!.valueChanges.pipe(
  //     startWith(""),
  //     map(value => this._documentationSignedScreening(value))
  //   );
  // }
  // private _documentationSignedScreening(value: string): measureQualifyName[] {
  //   value = !value ? "" : value;
  //   const filterValue = value.toString().toLowerCase();
  //   if (this.documentationSignList != undefined) {
  //     return this.documentationSignList.filter(option => option.qualifyMeasureName.toLowerCase().indexOf(filterValue) === 0);
  //   }
  // }

  // evaluationInterviewfilter() {
  //   this.evaluationInterviewScreenOptions = this.visitNoteCQMSForm.get('evaluationInterviewScreen')!.valueChanges.pipe(
  //     startWith(""),
  //     map(value => this._evaluationInterviewScreening(value))
  //   );
  // }
  // private _evaluationInterviewScreening(value: string): measureQualifyName[] {
  //   value = !value ? "" : value;
  //   const filterValue = value.toString().toLowerCase();
  //   if (this.evaluationOrInterviewList != undefined) {
  //     return this.evaluationOrInterviewList.filter(option => option.qualifyMeasureName.toLowerCase().indexOf(filterValue) === 0);
  //   }
  // }

  // closeRefScreenfilter() {
  //   this.closeRefScreenOptions = this.visitNoteCQMSForm.get('closeRefScreen')!.valueChanges.pipe(
  //     startWith(""),
  //     map(value => this._closeRefScreen(value))
  //   );
  // }

  // private _closeRefScreen(value: string): measureQualifyName[] {
  //   value=!value?"":value;
  //   const filterValue = value.toString().toLowerCase();
  //   if (this.closingRefList != undefined) {
  //     return this.closingRefList.filter(option => option.qualifyMeasureName.toLowerCase().indexOf(filterValue) === 0);
  //   }
  // }

  // highRiskMedfilter() {
  //   this.highRiskMedOptions = this.visitNoteCQMSForm.get('highRiskMedScreen')!.valueChanges.pipe(
  //     startWith(""),
  //     map(value => this._highRiskMed(value))
  //   );
  // }
  // private _highRiskMed(value: string): measureQualifyName[] {
  //   value = !value ? "" : value;
  //   const filterValue = value.toString().toLowerCase();
  //   if (this.highRiskMedList != undefined) {
  //     return this.highRiskMedList.filter(option => option.qualifyMeasureName.toLowerCase().indexOf(filterValue) === 0);
  //   }
  // }

  highRiskMedCriteriaTwofilter() {
    this.highRiskCriteriaTwoOptions = this.visitNoteCQMSForm.get('highRiskCriteriaTwo')!.valueChanges.pipe(
      startWith(""),
      map(value => this._highRiskMedCriteriaTwo(value))
    );
  }
  private _highRiskMedCriteriaTwo(value: string): measureQualifyName[] {
    value = !value ? "" : value;
    const filterValue = value.toString().toLowerCase();
    if (this.highRiskMedC2List != undefined) {
      return this.highRiskMedC2List.filter(option => option.qualifyMeasureName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  //#endregion

  onSelectionChanged(event, type: string, measureid, description, qualifyinfCode) {
    this.cqmsnotes = event;
    qualifyinfCode = Number(event.target.value);
    if (type === "Advance Care Plan") {
      if (this.advanceCareList != undefined) {
        let advnceCarelist = this.advanceCareList.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (advnceCarelist.length != 0) {
          this.advanceCareId = advnceCarelist[0].qualifyingCodeId.toString();
          this.isadvanceValueChange = false;
          //this.cqmsVisitNoteObjAdvanceCare.measureId = advnceCarelist[0].cqmsMeasureId;
          this.cqmsVisitNoteObjAdvanceCare.qualifyingCode = advnceCarelist[0].qualifyingCodeId;
          this.cqmsVisitNoteObjAdvanceCare.qualifyingDescription = advnceCarelist[0].qualifyMeasureName;
          this.cqmsVisitNoteObjAdvanceCare.isPerfomanceMed = advnceCarelist[0].isPerformance;
        } else {
          this.advanceCareId = "0";
        }
      }
    } else if (type === "Screening for Osteoporosis") {
      if (this.osteoporosisList != undefined) {
        let osteoList = this.osteoporosisList.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (osteoList.length != 0) {
          this.osteoporosisId = osteoList[0].qualifyingCodeId.toString();
          this.isOsteoporosisValueChange = false;
          this.cqmsVisitNoteObjOsteoporosis.qualifyingCode = osteoList[0].qualifyingCodeId;
          this.cqmsVisitNoteObjOsteoporosis.qualifyingDescription = osteoList[0].qualifyMeasureName;
          this.cqmsVisitNoteObjOsteoporosis.isPerfomanceMed = osteoList[0].isPerformance;
        } else {
          this.osteoporosisId = "0";
        }
      }
    } else if (type === "Pneumococcal Vaccination Status") {
      if (this.pneumococcalList != undefined) {
        let pneumococcallist = this.pneumococcalList.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (pneumococcallist.length != 0) {
          this.isPneumococcalChange = false;
          this.pneumococcalId = pneumococcallist[0].qualifyingCodeId.toString();
          //this.cqmsVisitNoteObj2.measureId = pneumococcallist[0].cqmsMeasureId;
          this.cqmsVisitNoteObjPneumococcal.qualifyingCode = pneumococcallist[0].qualifyingCodeId;
          this.cqmsVisitNoteObjPneumococcal.qualifyingDescription = pneumococcallist[0].qualifyMeasureName;
          this.cqmsVisitNoteObjPneumococcal.isPerfomanceMed = pneumococcallist[0].isPerformance;
        } else {
          this.pneumococcalId = "0";
        }
      }
    } else if (type === "High-Risk Medications C2") {
      if (this.highRiskMedC2List != undefined) {
        let highriskC2list = this.highRiskMedC2List.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (highriskC2list.length != 0) {
          this.isHighRiskC2Change = false;
          this.highRiskMedC2Id = highriskC2list[0].qualifyingCodeId.toString();
          //this.cqmsVisitNoteObj3.measureId = highriskC2list[0].cqmsMeasureId;
          this.cqmsVisitNoteRiskC2.qualifyingCode = highriskC2list[0].qualifyingCodeId;
          this.cqmsVisitNoteRiskC2.qualifyingDescription = highriskC2list[0].qualifyMeasureName;
          this.cqmsVisitNoteRiskC2.isPerfomanceMed = highriskC2list[0].isPerformance;
        } else {
          this.highRiskMedC2Id = "0";
        }
      }
    } else if (type === "Body Mass Index Screening") {
      if (this.bmiScreeningList != undefined) {
        let bmilist = this.bmiScreeningList.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (bmilist.length != 0) {
          this.isbmiChange = false;
          this.bmiId = bmilist[0].qualifyingCodeId.toString();
          //this.cqmsVisitNoteObj4.measureId = bmilist[0].cqmsMeasureId;
          this.cqmsVisitNoteBMI.qualifyingCode = bmilist[0].qualifyingCodeId;
          this.cqmsVisitNoteBMI.qualifyingDescription = bmilist[0].qualifyMeasureName;
          this.cqmsVisitNoteBMI.isPerfomanceMed = bmilist[0].isPerformance;
          this.bmiMeasureId = bmilist[0].cqmsMeasureId;
          this.IsChenageBMIMeasureId = true;
        } else {
          this.bmiId = "0";
        }
      }
    } else if (type === "Documentation of Current Medications") {
      if (this.documentationCurentMedList != undefined) {
        let docCurrentMedlist = this.documentationCurentMedList.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (docCurrentMedlist.length != 0) {
          this.isDocCurrentMedChange = false;
          this.docCurrentMedId = docCurrentMedlist[0].qualifyingCodeId.toString();
          //this.cqmsVisitNoteObj5.measureId = docCurrentMedlist[0].cqmsMeasureId;
          this.cqmsVisitNoteObjDocCurMed.qualifyingCode = docCurrentMedlist[0].qualifyingCodeId;
          this.cqmsVisitNoteObjDocCurMed.qualifyingDescription = docCurrentMedlist[0].qualifyMeasureName;
          this.cqmsVisitNoteObjDocCurMed.isPerfomanceMed = docCurrentMedlist[0].isPerformance;
        } else {
          this.docCurrentMedId = "0";
        }
      }
    }

    else if (type === "High-Risk Medications") {
      if (this.highRiskMedList != undefined) {
        let highrisklist = this.highRiskMedList.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (highrisklist.length != 0) {
          this.isHighRiskChange = false;
          this.highRiskMedId = highrisklist[0].qualifyingCodeId.toString();
          //this.cqmsVisitNoteObj9.measureId = highrisklist[0].cqmsMeasureId;
          this.cqmsVisitNoteObjHighRiskMed1.qualifyingCode = highrisklist[0].qualifyingCodeId;
          this.cqmsVisitNoteObjHighRiskMed1.qualifyingDescription = highrisklist[0].qualifyMeasureName;
          this.cqmsVisitNoteObjHighRiskMed1.isPerfomanceMed = highrisklist[0].isPerformance;
        } else {
          this.highRiskMedId = "0";
        }
      }
    } else if (type === "Closing the Referral Loop") {
      if (this.closingRefList != undefined) {
        let closeReflist = this.closingRefList.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (closeReflist.length != 0) {
          this.isCloseRefChange = false;
          this.closeRefId = closeReflist[0].qualifyingCodeId.toString();
          //this.cqmsVisitNoteObj10.measureId = closeReflist[0].cqmsMeasureId;
          this.cqmsVisitNoteObjCLR.qualifyingCode = closeReflist[0].qualifyingCodeId;
          this.cqmsVisitNoteObjCLR.qualifyingDescription = closeReflist[0].qualifyMeasureName;
          this.cqmsVisitNoteObjCLR.isPerfomanceMed = closeReflist[0].isPerformance;
        } else {
          this.closeRefId = "0";
        }
      }
    }
    else if (type === "Tobacco1") {
      if (this.TabacooC1List != undefined) {
        let _TabacooC1List = this.TabacooC1List.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (_TabacooC1List.length != 0) {
          this.isTobacco1Change = false;
          this.Tobacco1Id = _TabacooC1List[0].qualifyingCodeId.toString();
          this.cqmsVisitNoteObjCLR.qualifyingCode = _TabacooC1List[0].qualifyingCodeId;
          this.cqmsVisitNoteObjCLR.qualifyingDescription = _TabacooC1List[0].qualifyMeasureName;
          this.cqmsVisitNoteObjCLR.isPerfomanceMed = _TabacooC1List[0].isPerformance;
        } else {
          this.Tobacco1Id = "0";
        }
      }
    } else if (type === "AlcoholUse1") {
      if (this.AlcoholUseC1List != undefined) {
        let _AlcoholUseC1List = this.AlcoholUseC1List.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (_AlcoholUseC1List.length != 0) {
          this.cqmsVisitNoteObjAlcohol1.qualifyingCode = _AlcoholUseC1List[0].qualifyingCodeId;
          this.cqmsVisitNoteObjAlcohol1.qualifyingDescription = _AlcoholUseC1List[0].qualifyMeasureName;
          this.cqmsVisitNoteObjAlcohol1.isPerfomanceMed = _AlcoholUseC1List[0].isPerformance;
          const name = _AlcoholUseC1List[0].qualifyMeasureName;
          const isG2197 = name.includes('G2197');
          const isM1164orM1165 = name.includes('M1164') || name.includes('M1165');
          this.isAlcoholC2Disabled = isG2197 || isM1164orM1165;
          this.isAlcoholC3Disabled = isM1164orM1165;
          if (isM1164orM1165) {
            this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria2Screen: '', AlcoholUseCriteria3Screen: '' });
            this.cqmsVisitNoteObjAlcohol2.qualifyingCode = 0;
            this.cqmsVisitNoteObjAlcohol2.qualifyingDescription = '';
            this.cqmsVisitNoteObjAlcohol3.qualifyingCode = 0;
            this.cqmsVisitNoteObjAlcohol3.qualifyingDescription = '';
          } else if (isG2197) {
            this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria2Screen: '' });
            const g9262 = this.AlcoholUseC3List.find(x => x.qualifyMeasureName.includes('G9262'));
            if (g9262) {
              this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria3Screen: g9262.qualifyingCodeId });
              this.cqmsVisitNoteObjAlcohol3.qualifyingCode = g9262.qualifyingCodeId;
              this.cqmsVisitNoteObjAlcohol3.qualifyingDescription = g9262.qualifyMeasureName;
              this.cqmsVisitNoteObjAlcohol3.isPerfomanceMed = g9262.isPerformance;
            }
          } else {
            this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria3Screen: '' });
            this.cqmsVisitNoteObjAlcohol3.qualifyingCode = 0;
            this.cqmsVisitNoteObjAlcohol3.qualifyingDescription = '';
          }
        } else {
          this.isAlcoholC2Disabled = false;
          this.isAlcoholC3Disabled = false;
        }
      }
    } else if (type === "AlcoholUse2") {
      if (this.AlcoholUseC2List != undefined) {
        let _AlcoholUseC2List = this.AlcoholUseC2List.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (_AlcoholUseC2List.length != 0) {
          this.cqmsVisitNoteObjAlcohol2.qualifyingCode = _AlcoholUseC2List[0].qualifyingCodeId;
          this.cqmsVisitNoteObjAlcohol2.qualifyingDescription = _AlcoholUseC2List[0].qualifyMeasureName;
          this.cqmsVisitNoteObjAlcohol2.isPerfomanceMed = _AlcoholUseC2List[0].isPerformance;
        }
      }
    } else if (type === "AlcoholUse3") {
      if (this.AlcoholUseC3List != undefined) {
        let _AlcoholUseC3List = this.AlcoholUseC3List.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (_AlcoholUseC3List.length != 0) {
          this.cqmsVisitNoteObjAlcohol3.qualifyingCode = _AlcoholUseC3List[0].qualifyingCodeId;
          this.cqmsVisitNoteObjAlcohol3.qualifyingDescription = _AlcoholUseC3List[0].qualifyMeasureName;
          this.cqmsVisitNoteObjAlcohol3.isPerfomanceMed = _AlcoholUseC3List[0].isPerformance;
        }
      }
    } else if (type === "Depression Screening") {
      if (this.DepressionList != undefined) {
        let depressionList = this.DepressionList.filter(x => x.qualifyingCodeId === qualifyinfCode);
        if (depressionList.length != 0) {
          this.cqmsVisitNoteObjDepression.qualifyingCode = depressionList[0].qualifyingCodeId;
          this.cqmsVisitNoteObjDepression.qualifyingDescription = depressionList[0].qualifyMeasureName;
          this.cqmsVisitNoteObjDepression.isPerfomanceMed = depressionList[0].isPerformance;
          this.DepressionDesc = depressionList[0].qualifyMeasureName;
          this.isDepressionCrossOrRight = depressionList[0].isPerformance;
          this.encDepressionDate = new Date();
        }
      }
    }
    // else if (type === "Opioid Therapy") {
    //   if (this.opioidTherapy != undefined) {
    //     let opioidTherapylist = this.opioidTherapy.filter(x => x.qualifyCodeName === qualifyinfCode);
    //     if (opioidTherapylist.length != 0) {
    //       this.isOpioidChange = false;
    //       this.opioidTherapyId = opioidTherapylist[0].qualifyingCodeId.toString();
    //       //this.cqmsVisitNoteObj6.measureId = opioidTherapylist[0].cqmsMeasureId;
    //       this.cqmsVisitNoteObj6.qualifyingCode = opioidTherapylist[0].qualifyingCodeId;
    //       this.cqmsVisitNoteObj6.qualifyingDescription = opioidTherapylist[0].qualifyMeasureName;
    //       this.cqmsVisitNoteObj6.isPerfomanceMed = opioidTherapylist[0].isPerformance;
    //     } else {
    //       this.opioidTherapyId = "0";
    //     }
    //   }

    // }
    // else if (type === "Documentation of Signed") {
    //   if (this.documentationSignList != undefined) {
    //     let documentationSiglist = this.documentationSignList.filter(x => x.qualifyCodeName === qualifyinfCode);
    //     if (documentationSiglist.length != 0) {
    //       this.isDocSignChange = false;
    //       this.documentationSignId = documentationSiglist[0].qualifyingCodeId.toString();
    //       //this.cqmsVisitNoteObj7.measureId = documentationSiglist[0].cqmsMeasureId;
    //       this.cqmsVisitNoteObj7.qualifyingCode = documentationSiglist[0].qualifyingCodeId;
    //       this.cqmsVisitNoteObj7.qualifyingDescription = documentationSiglist[0].qualifyMeasureName;
    //       this.cqmsVisitNoteObj7.isPerfomanceMed = documentationSiglist[0].isPerformance;
    //     } else {
    //       this.documentationSignId = "0";
    //     }
    //   }
    // }

    // else if (type === "Evaluation or Interview for Risk") {
    //   if (this.evaluationOrInterviewList != undefined) {
    //     let evaluationlist = this.evaluationOrInterviewList.filter(x => x.qualifyCodeName === qualifyinfCode);
    //     if (evaluationlist.length != 0) {
    //       this.isEvaluationChange = false;
    //       this.evaluationId = evaluationlist[0].qualifyingCodeId.toString();
    //       //this.cqmsVisitNoteObj8.measureId = evaluationlist[0].cqmsMeasureId;
    //       this.cqmsVisitNoteObj8.qualifyingCode = evaluationlist[0].qualifyingCodeId;
    //       this.cqmsVisitNoteObj8.qualifyingDescription = evaluationlist[0].qualifyMeasureName;
    //       this.cqmsVisitNoteObj8.isPerfomanceMed = evaluationlist[0].isPerformance;
    //     } else {
    //       this.evaluationId = "0";
    //     }
    //   }
    // }
  }

  clearDropdownValues() {
    this.visitNoteCQMSForm.reset();
  }


  getVisitNoteFlags() {
    this.cqmsConfigurationService.GetCQMSVisitFlags(CommonComponents.patientId, CommonComponents.encounterId, 13).subscribe((data) => {
      this.flagsList = data;
      //**Split Bmi Value */
      //#region BMI
      var BMIvalue = this.flagsList[0].bmi;
      if (BMIvalue != null) {
        var arrBMI = BMIvalue.split('.')
        if (arrBMI.length === 1) {
          var BmiIndex = arrBMI[0]
        } else {
          var BmiIndex = arrBMI[0] + '.' + arrBMI[1].substring(0, 1)
        }
        this.encBmiVal = BmiIndex;
      }

      this.encQualifyDesc = this.flagsList[0].bmiQualifyDesc;
      if (this.encQualifyDesc != "" && this.encQualifyDesc != null) {
        this.encBMIDate = this.flagsList[0].bmiMetDate;
        this.isBMICrossOrRight = true;

        this.encQualifyDesc = (this.flagsList[0].bmiQualifyDesc.split(':').splice(1)).join(':');

      }
      else {
        // var enddate = new Date(2019, 11, 31);
        this.encBMIDate = this.flagsList[0].bmiEndDate;//new Date(2020, 11, 31);
        this.isBMICrossOrRight = false;
      }
      //#endregion
      this.encPreviousDate = this.flagsList[0].previousDate;
      //#region ADVANCE CARE PLAN
      this.advanceDesc = this.flagsList[0].advanceDesc;
      if (this.advanceDesc != "" && this.advanceDesc != null) {
        this.advanceDesc = (this.flagsList[0].advanceDesc.split(':').splice(1)).join(':');
        this.encAdvanceCareDate = this.flagsList[0].advanceMetDate;
        this.isAdvanceCrossOrRight = true;
      }
      else {
        this.encAdvanceCareDate = this.flagsList[0].advanceEndDate;//new Date(2020, 11, 31);
        this.isAdvanceCrossOrRight = false;
      }
      //#endregion

      //#region SCREENING FOR DEPRESSION AND FOLLOW-UP PLAN
      // Date/status only, sourced from Visit Note > Discussions > "26E.Screening for Depression and
      // Follow-Up Plan" (EMR_ENCOUNTER_CS_SUBCATEGEORIES). Matches BMI/Advance Care Plan: neither of
      // those ever populates a real "met" date in this procedure (only the not-yet-met EndDate is
      // ever computed), so a date only shows for the red/not-met state here too.
      if (this.flagsList[0].Depression && this.flagsList[0].DepressionDesc) {
        this.isDepressionCrossOrRight = true;
        this.visitNoteCQMSForm.patchValue({
          depressionScreen: this.flagsList[0].DepressionDesc.split(':')[0]
        });
      }
      else {
        this.encDepressionDate = this.flagsList[0].DepressionEndDate;
        this.isDepressionCrossOrRight = false;
      }
      //#endregion

      //#region OSTEOPOROSIS SCREENING
      this.OsteoporosisDesc = this.flagsList[0].OsteoporosisDesc;
      if (this.OsteoporosisDesc != "" && this.OsteoporosisDesc != null) {
        this.OsteoporosisDesc = (this.flagsList[0].OsteoporosisDesc.split(':').splice(1)).join(':');
        this.encOsteoporosisDate = this.flagsList[0].OsteoporosisMetDate;
        this.isOsteoporosisCrossOrRight = true;
      } else {
        this.encOsteoporosisDate = this.flagsList[0].OsteoporosisEndDate;
        this.isOsteoporosisCrossOrRight = false;
      }
      //#endregion

      //#region  pneumococcal
      this.pneumococcalDesc = this.flagsList[0].pneumococcalDesc;
      if (this.pneumococcalDesc != "" && this.pneumococcalDesc != null) {
        this.encPnemococcalDate = this.flagsList[0].pnemocalMetDate;
        this.isPnemocoCrossOrRight = true;
      }
      else {
        this.encPnemococcalDate = this.flagsList[0].pneumococcalEndDate; //new Date(2020, 11, 31);
        this.isPnemocoCrossOrRight = false;
      }
      //#endregion
      //#region  OPIOID THERAPY
      this.opioidTherapyDesc = this.flagsList[0].opioidDesc;
      if (this.opioidTherapyDesc != "" && this.opioidTherapyDesc != null) {
        this.opioidTherapyDate = this.flagsList[0].opioidDate;
        this.isOpioidCrossOrRight = true;
      }
      else {
        this.opioidTherapyDate = this.flagsList[0].opioidEndDate; //new Date(2020, 8, 30);
        this.isOpioidCrossOrRight = false;
      }
      //#endregion

      //#region Document Signed
      this.documentSignedDesc = this.flagsList[0].docSignedDesc;
      if (this.documentSignedDesc != "" && this.documentSignedDesc != null) {
        this.documentSignedDate = this.flagsList[0].docSignedDate;
        this.isDocSignCrossOrRight = true;
        this.visitNoteCQMSForm.controls.documentationSignedScreen.setValue('this.documentSignedDesc');
        this.visitNoteCQMSForm.controls.documentationSignedScreen.disable();
      }
      else {
        this.documentSignedDate = this.flagsList[0].docSignEndDate; //new Date(2020, 11, 31);
        this.isDocSignCrossOrRight = false;
        this.visitNoteCQMSForm.controls.documentationSignedScreen.enable();

      }

      //#endregion 

      //#region Elevation Desc


      this.evaluationInterviewDesc = this.flagsList[0].evaluationDesc;
      if (this.evaluationInterviewDesc != "" && this.evaluationInterviewDesc != null) {
        this.evaluationInterviewDate = this.flagsList[0].evaluationDate;
        this.isEvaluationCrossOrRight = true;
      }
      else {
        this.evaluationInterviewDate = this.flagsList[0].evaluationEndDate; //new Date(2020, 11, 31);
        this.isEvaluationCrossOrRight = false;
      }
      //#endregion 


      // #region  CurrentMed
      if (!this.flagsList[0].isDocCurrentMed) { //if the document is not met the patient age less than 18
        this.docCurrentMedDate = null;
        this.isCurrentMedCrossOrRight = false;
        this.docCurrentMedDesc = "";
        this.visitNoteCQMSForm.patchValue({
          docCurrentMedScreen: ""
        });
      }
      else {
        this.docCurrentMedDesc = this.flagsList[0].docCurrentMedDesc
        if (this.docCurrentMedDesc != "" && this.docCurrentMedDesc != null) {

          this.visitNoteCQMSForm.patchValue({
            docCurrentMedScreen: this.docCurrentMedDesc.split(':')[0]
          });
          this.docCurrentMedDesc = (this.flagsList[0].docCurrentMedDesc.split(':').splice(1)).join(':');
          this.docCurrentMedDate = this.flagsList[0].docCurrentMedDate;
          this.isCurrentMedCrossOrRight = true;
        }
        else {
          this.docCurrentMedDate = this.flagsList[0].docCurrentMedEndYear; //new Date(2020, 11, 31);
          this.isCurrentMedCrossOrRight = false;
          this.visitNoteCQMSForm.patchValue({
            docCurrentMedScreen: ''
          });
        }
      }
      //#endregion 
      //#region  CloseRef
      this.CloseRefDesc = this.flagsList[0].CloseRefDesc;
      if (this.CloseRefDesc != "" && this.CloseRefDesc != null) {
        this.CloseRefDate = this.flagsList[0].CloseRefDate;
        this.isCloseRefCrossOrRight = true;
      }
      else {
        this.CloseRefDate = this.flagsList[0].CloseRefEndDate; //new Date(2020, 11, 31);
        this.isCloseRefCrossOrRight = false;
      }
      this.isCloseRefShow = this.flagsList[0].isCloseRef;
      //  if (this.flagsList[0].isCloseRef) {
      //  ddd
      if (!this.flagsList[0].isCloseRef) { //if the document is not met the patient age less than 18
        // this.CloseRefDesc = this.flagsList[0].CloseRefDesc;
        // if (this.CloseRefDesc != "" && this.CloseRefDesc != null) {
        //   this.CloseRefDate = this.flagsList[0].CloseRefDate;

        this.CloseRefDate = null;
        this.isCloseRefCrossOrRight = false;
        this.CloseRefDesc = "";
        this.visitNoteCQMSForm.patchValue({
          closeRefScreen: ""
        });
      }
      else {
        this.CloseRefDesc = this.flagsList[0].CloseRefDesc
        if (this.CloseRefDesc != "" && this.CloseRefDesc != null) {

          this.visitNoteCQMSForm.patchValue({
            closeRefScreen: this.CloseRefDesc.split(':')[0]
          });
          this.CloseRefDesc = (this.flagsList[0].CloseRefDesc.split(':').splice(1)).join(':');
          this.CloseRefDate = this.flagsList[0].CloseRefDate;
          this.isCloseRefCrossOrRight = true;
        }
        else {
          this.CloseRefDate = this.flagsList[0].CloseRefDate; //new Date(2020, 11, 31);
          this.isCloseRefCrossOrRight = false;
          this.visitNoteCQMSForm.patchValue({
            closeRefScreen: ''
          });
        }
      }
      //   ddd
      // if(this.visitNoteCQMSForm)
      //           this.visitNoteCQMSForm.controls.closeRefScreen.disable();
      //  this.isCloseRefShow = false;
      //  } else {
      //    if(this.visitNoteCQMSForm)
      //            this.visitNoteCQMSForm.controls.closeRefScreen.enable();
      //this.isCloseRefShow = true;
      // }
      //#endregion   

      // #region   highRisk Med

      if (this.flagsList[0].highRiskMedDesc != "" && this.flagsList[0].highRiskMedDesc != null && this.flagsList[0].highRiskMedDesc != undefined) {
        this.flagsList[0].highRiskMedDesc.split(':').shift();
        //   this.highRiskMedDesc = this.flagsList[0].highRiskMedDesc;
        // } else {
        //   this.highRiskMedDesc = this.flagsList[0].highRiskMedDesc;
      }


      if (this.flagsList[0].highRiskMedDesc != "" && this.flagsList[0].highRiskMedDesc != null && this.flagsList[0].highRiskMedDesc != undefined) {
        this.highRiskMedDesc = this.flagsList[0].highRiskMedDesc.replace("29: ", "");
      } else {
        this.highRiskMedDesc = this.flagsList[0].highRiskMedDesc;
      }
      if (this.highRiskMedDesc != "" && this.highRiskMedDesc != null) {
        this.highRiskMedDate = this.flagsList[0].highRiskMedDate;
        this.isHighRiskMedCrossOrRight = true;
      }
      else {
        this.highRiskMedDate = this.flagsList[0].highRiskMedEndYear; //new Date(2020, 11, 31);
        this.isHighRiskMedCrossOrRight = false;
      }
      //#endregion

      //#region   C2highRiskMed

      if (this.flagsList[0].C2highRiskMedDesc != "" && this.flagsList[0].C2highRiskMedDesc != null && this.flagsList[0].C2highRiskMedDesc != undefined) {
        this.flagsList[0].C2highRiskMedDesc.split(':').shift();
      }
      // this.C2highRiskMedDesc = this.flagsList[0].C2highRiskMedDesc
      if (this.flagsList[0].C2highRiskMedDesc != "" && this.flagsList[0].C2highRiskMedDesc != null && this.flagsList[0].C2highRiskMedDesc != undefined) {
        this.C2highRiskMedDesc = this.flagsList[0].C2highRiskMedDesc.replace("29: ", "");
      } else {
        this.C2highRiskMedDesc = this.flagsList[0].C2highRiskMedDesc;
      }

      if (this.C2highRiskMedDesc != "" && this.C2highRiskMedDesc != null) {
        this.C2highRiskMedDate = this.flagsList[0].C2highRiskMedDate;
        this.isC2HighRiskMedCrossOrRight = true;
      }
      else {
        this.C2highRiskMedDate = this.flagsList[0].highRiskMedEndYear; //new Date(2020, 11, 31);
        this.isC2HighRiskMedCrossOrRight = false;
      }
      //#endregion




      // #region  Tabacco1
      if (!this.flagsList[0].isTabaccoShow1) { //if the document is not met the patient age less than 18
        this.TabaccoC1Date = null;
        this.isTabaccco1CrossOrRight = false;
        this.TabaccoC1Desc = "";
        this.visitNoteCQMSForm.patchValue({
          TabacooCriteria1Screen: ""
        });
      }
      else {
        this.TabaccoC1Desc = this.flagsList[0].Tabacco1QualifyDesc
        if (this.TabaccoC1Desc != "" && this.TabaccoC1Desc != null) {

          this.visitNoteCQMSForm.patchValue({
            TabacooCriteria1Screen: this.TabaccoC1Desc.split(':')[0]
          });
          this.TabaccoC1Desc = (this.flagsList[0].Tabacco1QualifyDesc.split(':').splice(1)).join(':');
          this.TabaccoC1Date = this.flagsList[0].Tabacco1EndDate;
          this.isTabaccco1CrossOrRight = true;
        }
        else {
          this.TabaccoC1Date = this.flagsList[0].Tabacco1EndDate; //new Date(2020, 11, 31);
          this.isTabaccco1CrossOrRight = false;
          this.visitNoteCQMSForm.patchValue({
            TabacooCriteria1Screen: ''
          });
        }
      }
      //#endregion 

      // #region  Tabacco2
      if (!this.flagsList[0].isTabaccoShow2) { //if the document is not met the patient age less than 18
        this.TabaccoC2Date = null;
        this.isTabaccco2CrossOrRight = false;
        this.TabaccoC2Desc = "";
        this.visitNoteCQMSForm.patchValue({
          TabacooCriteria2Screen: ""
        });
      }
      else {
        this.TabaccoC2Desc = this.flagsList[0].Tabacco2QualifyDesc
        if (this.TabaccoC2Desc != "" && this.TabaccoC2Desc != null) {

          this.visitNoteCQMSForm.patchValue({
            TabacooCriteria2Screen: this.TabaccoC2Desc.split(':')[0]
          });
          this.TabaccoC2Desc = (this.flagsList[0].Tabacco2QualifyDesc.split(':').splice(1)).join(':');
          this.TabaccoC2Date = this.flagsList[0].Tabacco2EndDate;
          this.isTabaccco2CrossOrRight = true;
        }
        else {
          this.TabaccoC2Date = this.flagsList[0].Tabacco2EndDate; //new Date(2020, 11, 31);
          this.isTabaccco2CrossOrRight = false;
          this.visitNoteCQMSForm.patchValue({
            TabacooCriteria2Screen: ''
          });
        }
      }
      //#endregion 

      // #region  Tabacco3
      if (!this.flagsList[0].isTabaccoShow3) { //if the document is not met the patient age less than 18
        this.TabaccoC3Date = null;
        this.isTabaccco3CrossOrRight = false;
        this.TabaccoC3Desc = "";
        this.visitNoteCQMSForm.patchValue({
          TabacooCriteria3Screen: ""
        });
      }
      else {
        this.TabaccoC3Desc = this.flagsList[0].Tabacco3QualifyDesc
        if (this.TabaccoC3Desc != "" && this.TabaccoC3Desc != null) {

          this.visitNoteCQMSForm.patchValue({
            TabacooCriteria3Screen: this.TabaccoC3Desc.split(':')[0]
          });
          this.TabaccoC3Desc = (this.flagsList[0].Tabacco3QualifyDesc.split(':').splice(1)).join(':');
          this.TabaccoC3Date = this.flagsList[0].Tabacco3EndDate;
          this.isTabaccco3CrossOrRight = true;
        }
        else {
          this.TabaccoC3Date = this.flagsList[0].Tabacco3EndDate; //new Date(2020, 11, 31);
          this.isTabaccco3CrossOrRight = false;
          this.visitNoteCQMSForm.patchValue({
            TabacooCriteria3Screen: ''
          });
        }
      }
      //#endregion 

      // #region  AlcoholUse1
      if (!this.flagsList[0].isAlcoholUseShow1) {
        this.AlcoholUseC1Date = null;
        this.isAlcoholUseC1CrossOrRight = false;
        this.AlcoholUseC1Desc = "";
        this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria1Screen: "" });
      } else {
        this.AlcoholUseC1Desc = this.flagsList[0].AlcoholUse1QualifyDesc;
        if (this.AlcoholUseC1Desc != "" && this.AlcoholUseC1Desc != null) {
          this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria1Screen: this.AlcoholUseC1Desc.split(':')[0] });
          this.AlcoholUseC1Desc = (this.flagsList[0].AlcoholUse1QualifyDesc.split(':').splice(1)).join(':');
          this.AlcoholUseC1Date = this.flagsList[0].AlcoholUse1EndDate;
          this.isAlcoholUseC1CrossOrRight = true;
        } else {
          this.AlcoholUseC1Date = this.flagsList[0].AlcoholUse1EndDate;
          this.isAlcoholUseC1CrossOrRight = false;
          this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria1Screen: '' });
        }
      }
      //#endregion

      // #region  AlcoholUse2
      if (!this.flagsList[0].isAlcoholUseShow2) {
        this.AlcoholUseC2Date = null;
        this.isAlcoholUseC2CrossOrRight = false;
        this.AlcoholUseC2Desc = "";
        this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria2Screen: "" });
      } else {
        this.AlcoholUseC2Desc = this.flagsList[0].AlcoholUse2QualifyDesc;
        if (this.AlcoholUseC2Desc != "" && this.AlcoholUseC2Desc != null) {
          this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria2Screen: this.AlcoholUseC2Desc.split(':')[0] });
          this.AlcoholUseC2Desc = (this.flagsList[0].AlcoholUse2QualifyDesc.split(':').splice(1)).join(':');
          this.AlcoholUseC2Date = this.flagsList[0].AlcoholUse2EndDate;
          this.isAlcoholUseC2CrossOrRight = true;
        } else {
          this.AlcoholUseC2Date = this.flagsList[0].AlcoholUse2EndDate;
          this.isAlcoholUseC2CrossOrRight = false;
          this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria2Screen: '' });
        }
      }
      //#endregion

      // #region  AlcoholUse3
      if (!this.flagsList[0].isAlcoholUseShow3) {
        this.AlcoholUseC3Date = null;
        this.isAlcoholUseC3CrossOrRight = false;
        this.AlcoholUseC3Desc = "";
        this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria3Screen: "" });
      } else {
        this.AlcoholUseC3Desc = this.flagsList[0].AlcoholUse3QualifyDesc;
        if (this.AlcoholUseC3Desc != "" && this.AlcoholUseC3Desc != null) {
          this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria3Screen: this.AlcoholUseC3Desc.split(':')[0] });
          this.AlcoholUseC3Desc = (this.flagsList[0].AlcoholUse3QualifyDesc.split(':').splice(1)).join(':');
          this.AlcoholUseC3Date = this.flagsList[0].AlcoholUse3EndDate;
          this.isAlcoholUseC3CrossOrRight = true;
        } else {
          this.AlcoholUseC3Date = this.flagsList[0].AlcoholUse3EndDate;
          this.isAlcoholUseC3CrossOrRight = false;
          this.visitNoteCQMSForm.patchValue({ AlcoholUseCriteria3Screen: '' });
        }
      }
      //#endregion

      if (this.flagsList[0].advanceDesc != "" && this.flagsList[0].advanceDesc != null) {
        if (this.visitNoteCQMSForm)
          this.visitNoteCQMSForm.controls.advanceCarePlan.disable();
      } else {
        if (this.visitNoteCQMSForm)
          this.visitNoteCQMSForm.controls.advanceCarePlan.enable();
      }
      if (this.flagsList[0].OsteoporosisDesc != "" && this.flagsList[0].OsteoporosisDesc != null) {
        if (this.visitNoteCQMSForm)
          this.visitNoteCQMSForm.controls.osteoporosisScreen.disable();
      } else {
        if (this.visitNoteCQMSForm)
          this.visitNoteCQMSForm.controls.osteoporosisScreen.enable();
      }
      // if (this.flagsList[0].isPneumococcal) {
      //   if(this.visitNoteCQMSForm)
      //           this.visitNoteCQMSForm.controls.pneumococcal.disable();
      //   this.isPnemocoShow = false;
      // } else {
      //   if(this.visitNoteCQMSForm)
      //           this.visitNoteCQMSForm.controls.pneumococcal.enable();
      //   this.isPnemocoShow = true;
      // }
      // if (this.flagsList[0].isBMI) {
      //   this.visitNoteCQMSForm.controls.bmiScreen.disable();
      //   this.isbmiShow = false;
      // } else {
      //   this.visitNoteCQMSForm.controls.bmiScreen.enable();
      //   this.isbmiShow = true;
      // }
      if (this.flagsList[0].isOpiod) {
        if (this.visitNoteCQMSForm)
          this.visitNoteCQMSForm.controls.opioidTherapyScreen.disable();
        this.isOpioidTherapyShow = false;
      } else {
        if (this.visitNoteCQMSForm)
          this.visitNoteCQMSForm.controls.opioidTherapyScreen.enable();
        this.isOpioidTherapyShow = true;
      }
      if (this.flagsList[0].isDocSign) {
        if (this.visitNoteCQMSForm)
          this.visitNoteCQMSForm.controls.documentationSignedScreen.disable();
        this.isDocSignShow = false;
      } else {
        if (this.visitNoteCQMSForm)
          this.visitNoteCQMSForm.controls.documentationSignedScreen.enable();
        this.isDocSignShow = true;
      }
      if (this.flagsList[0].isEvaluation) {
        if (this.visitNoteCQMSForm)
          this.visitNoteCQMSForm.controls.evaluationInterviewScreen.disable();
        this.isEvaluationShow = false;
      } else {
        if (this.visitNoteCQMSForm)
          this.visitNoteCQMSForm.controls.evaluationInterviewScreen.enable();
        this.isEvaluationShow = true;
      }
      this.isAdvanceShow = this.flagsList[0].isAdvanceCare
      this.isOsteoporosisShow = this.flagsList[0].IsOsteoporosis
      this.isDocCurrentMedShow = this.flagsList[0].isDocCurrentMed
      this.isPnemocoShow = this.flagsList[0].isPneumococcal
      this.isbmiShow = this.flagsList[0].isBMI
      this.isHighRiskMedShow = this.flagsList[0].isHighRiskMed
      this.isTabaccoShow1 = this.flagsList[0].isTabaccoShow1
      this.isTabaccoShow2 = this.flagsList[0].isTabaccoShow2
      this.isTabaccoShow3 = this.flagsList[0].isTabaccoShow3
      this.isC2HighRiskMedShow = this.flagsList[0].isC2HighRiskMed
      this.isCloseRefShow=this.flagsList[0].isCloseRef
      this.isAlcoholUseShow1 = this.flagsList[0].isAlcoholUseShow1
      this.isAlcoholUseShow2 = this.flagsList[0].isAlcoholUseShow2
      this.isAlcoholUseShow3 = this.flagsList[0].isAlcoholUseShow3

      // if (this.flagsList[0].isDocCurrentMed) {

      // if(this.visitNoteCQMSForm)
      //         this.visitNoteCQMSForm.controls.docCurrentMedScreen.disable();
      //this.isDocCurrentMedShow = false;
      //  } else {
      //  if(this.visitNoteCQMSForm)
      //       this.visitNoteCQMSForm.controls.docCurrentMedScreen.enable();

      //this.isDocCurrentMedShow = true;
      //  }
      // // if (this.flagsList[0].isHighRiskMed) {
      // //   if (this.visitNoteCQMSForm)
      // //     this.visitNoteCQMSForm.controls.highRiskMedScreen.disable();
      // //   //this.isHighRiskMedShow = false;
      // // } else {
      // //   if (this.visitNoteCQMSForm)
      // //     this.visitNoteCQMSForm.controls.highRiskMedScreen.enable();
      // //   //this.isHighRiskMedShow = true;
      // // }
      // if (this.flagsList[0].isC2HighRiskMed) {
      //   if (this.visitNoteCQMSForm)
      //     this.visitNoteCQMSForm.controls.highRiskCriteriaTwo.disable();
      //   this.isC2HighRiskMedShow = false;
      // } else {
      //   if (this.visitNoteCQMSForm)
      //     this.visitNoteCQMSForm.controls.highRiskCriteriaTwo.enable();
      //   this.isC2HighRiskMedShow = true;
      // }



      this.MeasureNameDropDownsBinding(false, '');
      this.spinner.hide();
    },
      (err: any) => {
        console.log(err)
        this.spinner.hide();
      })
  }
  bindNewBMIScreen() {
    var i: number = 0
    this.bmiNewScreenList.forEach(ele => {
      var spiltVal: string[] = ele.qualifyMeasureName.split(' _,');
      if (this.flagsList[0].bmi != "" && this.flagsList[0].bmi != null) {
        if (spiltVal.length == 1) {
          var withBMIValue = spiltVal[0];
          this.bmiNewScreenList[i].qualifyMeasureName = withBMIValue;
        } else {
          var withBMIValue = spiltVal[0] + ' ' + this.encBmiVal + ',' + spiltVal[1];
          this.bmiNewScreenList[i].qualifyMeasureName = withBMIValue;
        }
      } else {
        if (spiltVal.length == 1) {
          var withoutBMIValue = spiltVal[0];
          this.bmiNewScreenList[i].qualifyMeasureName = withoutBMIValue;
        } else {
          var withoutBMIValue = spiltVal[0] + ',' + spiltVal[1];
          this.bmiNewScreenList[i].qualifyMeasureName = withoutBMIValue;
        }
      }
      i = i + 1;
    });
    // this.bmiScreeningList = this.bmiNewScreenList;
    this.bmi = Number(this.flagsList[0].bmi);
    if (this.bmi > 0) {
      if (this.bmi < 18.5) {
        // this.visitNoteCQMSForm.patchValue({
        //   bmiScreen: this.bmiScreeningList[0].qualifyMeasureName
        // });
        this.bmiScreeningList[0] = this.bmiNewScreenList[2];

      } else if (18.5 <= this.bmi && this.bmi <= 24.9) {
        // this.visitNoteCQMSForm.patchValue({
        //   bmiScreen: this.bmiScreeningList[1].qualifyMeasureName
        // });
        this.bmiScreeningList[0] = this.bmiNewScreenList[0];
      } else if (25 <= this.bmi && this.bmi <= 29.9) {
        // this.visitNoteCQMSForm.patchValue({
        //   bmiScreen: this.bmiScreeningList[2].qualifyMeasureName
        // });
        this.bmiScreeningList[0] = this.bmiNewScreenList[1];
      } else if (30 <= this.bmi) {
        // this.visitNoteCQMSForm.patchValue({
        //   bmiScreen: this.bmiScreeningList[3].qualifyMeasureName
        // });
        this.bmiScreeningList[0] = this.bmiNewScreenList[3];
      }
    }
    else {
      this.bmiScreeningList = this.bmiNewScreenList;
    }
    //** */ this.bmiScreeningfilter();
  }

  showAllMeasures(event) {
    if (event.checked) {
      if (this.isAdvanceShow == false) {
        this.isAdvanceShow = true;
        this.visitNoteCQMSForm.controls.advanceCarePlan.disable();
      }
      if (this.isPnemocoShow == false) {
        this.isPnemocoShow = true;
        this.visitNoteCQMSForm.controls.pneumococcal.disable();
      }
      if (this.isbmiShow == false) {
        this.isbmiShow = true;
        this.visitNoteCQMSForm.controls.bmiScreen.disable();
      }
      if (this.isOpioidTherapyShow == false) {
        this.isOpioidTherapyShow = true;
        this.visitNoteCQMSForm.controls.opioidTherapyScreen.disable();
      }
      if (this.isDocSignShow == false) {
        this.isDocSignShow = true;
        this.visitNoteCQMSForm.controls.documentationSignedScreen.disable();
      }
      if (this.isEvaluationShow == false) {
        this.isEvaluationShow = true;
        this.visitNoteCQMSForm.controls.evaluationInterviewScreen.disable();
      }
      if (this.isDocCurrentMedShow == false) {
        this.isDocCurrentMedShow = true;
        this.visitNoteCQMSForm.controls.docCurrentMedScreen.disable();
      }
      if (this.isHighRiskMedShow == false) {
        this.isHighRiskMedShow = true;
        //  this.visitNoteCQMSForm.controls.highRiskMedScreen.disable();
      }
      if (this.isC2HighRiskMedShow == false) {
        this.isC2HighRiskMedShow = true;
        this.visitNoteCQMSForm.controls.highRiskCriteriaTwo.disable();
      }
      if (this.isCloseRefShow == false) {
        this.isCloseRefShow = true;
        this.visitNoteCQMSForm.controls.closeRefScreen.disable();
      }
      if (this.isTabaccoShow1 == false) {
        this.isTabaccoShow1 = true;
        //this.visitNoteCQMSForm.controls..disable();
      }
      if (this.isTabaccoShow2 == false) {
        this.isTabaccoShow2 = true;
        //this.visitNoteCQMSForm.controls..disable();
      }
      if (this.isTabaccoShow3 == false) {
        this.isTabaccoShow3 = true;
      }
      if (this.isAlcoholUseShow1 == false) {
        this.isAlcoholUseShow1 = true;
      }
      if (this.isAlcoholUseShow2 == false) {
        this.isAlcoholUseShow2 = true;
      }
      if (this.isAlcoholUseShow3 == false) {
        this.isAlcoholUseShow3 = true;
      }
      // this.isAdvanceShow = true;
      // this.isPnemocoShow = true;
      // this.isbmiShow = true;
      // this.isOpioidTherapyShow = true;
      // this.isDocSignShow = true;
      // this.isEvaluationShow = true;
      //this.visitNoteCQMSForm.controls.bmiScreen.disable();
    } else {
      // this.isAdvanceShow = false;
      // this.isPnemocoShow = false;
      // this.isbmiShow = false;
      // this.isOpioidTherapyShow = false;
      // this.isDocSignShow = false;
      // this.isEvaluationShow = false;
      this.getVisitNoteFlags();
    }
  }
  measureChange(type) {

    if (type == 'Advance Care') {
      this.isadvanceValueChange = true;
    } else if (type == 'Pneumococcal Vaccination') {
      this.isPneumococcalChange = true;
    } else if (type == 'BMI') {
      this.isbmiChange = true;
    } else if (type == 'Opioid Therapy') {
      this.isOpioidChange = true;
    } else if (type == 'Evaluation') {
      this.isEvaluationChange = true;
    } else if (type == 'Documentation of Signed') {
      this.isDocSignChange = true;
    } else if (type == 'Doc of Current Medications') {
      this.isDocCurrentMedChange = true;
    } else if (type == 'High-Risk Medications') {
      this.isHighRiskChange = true;
    } else if (type == 'High-Risk Medications C2') {
      this.isHighRiskC2Change = true;
    } else if (type == 'Closing the Referral Loop') {
      this.isCloseRefChange = true;
    }
    else if (type == "Tobacco1") {
      this.isTobacco1Change = true;
    }
  }

  backtoCQMSDashBoard() {
    sessionStorage.removeItem("isCQMSVisitNote");
    // this.cqmstactiveTab2.emit()
    localStorage.setItem('cqmstab2', '2');
    this.router.navigateByUrl('/ReportsCqms');
  }
  onCQMSCancel() {
    this.cqmsConfigurationService.stringSubject.next(false);
    //this.cqmsCancel.emit(false);
    //this.visitheader._visitinfotoggleSidebars(false);

  }

  // teFun() {
  //   alert()
  //   this.cqmsConfigurationService.stringSubject.next('hello');
  // }





  // showFulltext1() {
  //   this.bmiScreenTooltip = $('#bmiScreen option:selected').text() as any;
  // }
}
